/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as OrganisationRouteRouteImport } from "./routes/$organisation/route"
import { Route as AuthenticatedRouteRouteImport } from "./routes/_authenticated/route"
import { Route as GuestRouteRouteImport } from "./routes/_guest/route"
import { Route as OrganisationIndexRouteImport } from "./routes/$organisation/index"
import { Route as OrganisationAuthenticatedRouteRouteImport } from "./routes/$organisation/_authenticated/route"
import { Route as OrganisationGuestRouteRouteImport } from "./routes/$organisation/_guest/route"
import { Route as AuthenticatedAdminRouteRouteImport } from "./routes/_authenticated/admin/route"
import { Route as OrganisationAuthenticatedOrganisationRouteRouteImport } from "./routes/$organisation/_authenticated/_organisation/route"
import { Route as OrganisationPortalPortalRouteRouteImport } from "./routes/$organisation/portal/_portal/route"
import { Route as AuthenticatedAdminIndexRouteImport } from "./routes/_authenticated/admin/index"
import { Route as GuestForgotPasswordIndexRouteImport } from "./routes/_guest/forgot-password/index"
import { Route as GuestLoginIndexRouteImport } from "./routes/_guest/login/index"
import { Route as OrganisationAuthenticatedOrganisationMainRouteRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/route"
import { Route as OrganisationAuthenticatedOrganisationSettingsRouteRouteImport } from "./routes/$organisation/_authenticated/_organisation/settings/route"
import { Route as OrganisationGuestForgotPasswordIndexRouteImport } from "./routes/$organisation/_guest/forgot-password/index"
import { Route as OrganisationGuestLoginIndexRouteImport } from "./routes/$organisation/_guest/login/index"
import { Route as OrganisationPortalPortalIndexRouteImport } from "./routes/$organisation/portal/_portal/index"
import { Route as OrganisationPortalLoginIndexRouteImport } from "./routes/$organisation/portal/login/index"
import { Route as AuthenticatedAdminOrganisationsIndexRouteImport } from "./routes/_authenticated/admin/organisations/index"
import { Route as AuthenticatedAdminSettingsIndexRouteImport } from "./routes/_authenticated/admin/settings/index"
import { Route as AuthenticatedOrganisationsNoneIndexRouteImport } from "./routes/_authenticated/organisations/none/index"
import { Route as AuthenticatedOrganisationsSelectIndexRouteImport } from "./routes/_authenticated/organisations/select/index"
import { Route as OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRouteImport } from "./routes/$organisation/_authenticated/_organisation/filings/$filingId/route"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/route"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/route"
import { Route as OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRouteImport } from "./routes/$organisation/_authenticated/_organisation/issues/$issueId/route"
import { Route as OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRouteImport } from "./routes/$organisation/_authenticated/_organisation/reviews/$reviewId/route"
import { Route as OrganisationAuthenticatedOrganisationSettingsIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/settings/index"
import { Route as OrganisationAuthenticatedOrganisationTriageIssueIdRouteRouteImport } from "./routes/$organisation/_authenticated/_organisation/triage/$issueId/route"
import { Route as AuthenticatedAdminOrganisationsOrganisationSlugIndexRouteImport } from "./routes/_authenticated/admin/organisations/$organisationSlug/index"
import { Route as AuthenticatedAdminOrganisationsCreateIndexRouteImport } from "./routes/_authenticated/admin/organisations/create/index"
import { Route as OrganisationAuthenticatedOrganisationMainComplianceIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/compliance/index"
import { Route as OrganisationAuthenticatedOrganisationMainDashboardIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/dashboard/index"
import { Route as OrganisationAuthenticatedOrganisationMainFilingsIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/filings/index"
import { Route as OrganisationAuthenticatedOrganisationMainFirmsIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/firms/index"
import { Route as OrganisationAuthenticatedOrganisationMainIndividualsIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/individuals/index"
import { Route as OrganisationAuthenticatedOrganisationMainIssuesIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/issues/index"
import { Route as OrganisationAuthenticatedOrganisationMainOversightIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/oversight/index"
import { Route as OrganisationAuthenticatedOrganisationMainRequestsIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/requests/index"
import { Route as OrganisationAuthenticatedOrganisationMainReviewsIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/reviews/index"
import { Route as OrganisationAuthenticatedOrganisationMainRiskIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/risk/index"
import { Route as OrganisationAuthenticatedOrganisationMainTasksIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/tasks/index"
import { Route as OrganisationAuthenticatedOrganisationMainTriageIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/triage/index"
import { Route as OrganisationAuthenticatedOrganisationFilingsFilingIdIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/filings/$filingId/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/index"
import { Route as OrganisationAuthenticatedOrganisationIssuesIssueIdIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/issues/$issueId/index"
import { Route as OrganisationAuthenticatedOrganisationReviewsReviewIdIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/reviews/$reviewId/index"
import { Route as OrganisationAuthenticatedOrganisationSettingsProfileIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/settings/profile/index"
import { Route as OrganisationAuthenticatedOrganisationTriageIssueIdIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/triage/$issueId/index"
import { Route as OrganisationPortalPortalTasksTaskIdIndexRouteImport } from "./routes/$organisation/portal/_portal/tasks/$taskId/index"
import { Route as OrganisationAuthenticatedOrganisationMainComplianceGapKeyIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/compliance/$gapKey/index"
import { Route as OrganisationAuthenticatedOrganisationMainFirmsCreateIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/firms/create/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdActivityIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/activity/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/addresses/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/agreement/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/authorisation/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/details/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdFilesIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/files/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdFilingsIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/filings/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdIssuesIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/issues/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/onboarding/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/ownership/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/people/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdReviewsIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/reviews/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdRiskIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/risk/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdScopeIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/scope/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdActivityIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/activity/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/addresses/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdAppointmentsIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/appointments/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/checks/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/employment/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/files/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/identity/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdIssuesIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/issues/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/record/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdRegulatoryIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/regulatory/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/review/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewsIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/reviews/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdRiskIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/risk/index"
import { Route as OrganisationAuthenticatedOrganisationReviewsReviewIdApproveIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/reviews/$reviewId/approve/index"
import { Route as OrganisationAuthenticatedOrganisationReviewsReviewIdCancelIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/reviews/$reviewId/cancel/index"
import { Route as OrganisationAuthenticatedOrganisationReviewsReviewIdDueIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/reviews/$reviewId/due/index"
import { Route as OrganisationAuthenticatedOrganisationReviewsReviewIdFirmIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/reviews/$reviewId/firm/index"
import { Route as OrganisationAuthenticatedOrganisationSettingsOrganisationActivityIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/settings/organisation/activity/index"
import { Route as OrganisationAuthenticatedOrganisationSettingsOrganisationArAgreementsIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/settings/organisation/ar-agreements/index"
import { Route as OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/settings/organisation/authorisation/index"
import { Route as OrganisationAuthenticatedOrganisationSettingsOrganisationBrandingIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/settings/organisation/branding/index"
import { Route as OrganisationAuthenticatedOrganisationSettingsOrganisationEmailsIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/settings/organisation/emails/index"
import { Route as OrganisationAuthenticatedOrganisationSettingsOrganisationExportIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/settings/organisation/export/index"
import { Route as OrganisationAuthenticatedOrganisationSettingsOrganisationOffboardingIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/settings/organisation/offboarding/index"
import { Route as OrganisationAuthenticatedOrganisationSettingsOrganisationOnboardingIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/settings/organisation/onboarding/index"
import { Route as OrganisationAuthenticatedOrganisationSettingsOrganisationRequirementsIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/settings/organisation/requirements/index"
import { Route as OrganisationAuthenticatedOrganisationSettingsOrganisationTeamIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/settings/organisation/team/index"
import { Route as OrganisationAuthenticatedOrganisationMainRiskFactorsFactorKeyIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/_main/risk/factors/$factorKey/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesEditIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/addresses/edit/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementAgreementIdIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/agreement/$agreementId/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationAppointmentIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/authorisation/appointment/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsEditIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/details/edit/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdFilesFileIdIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/files/$fileId/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingNewIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/onboarding/new/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipEditIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/ownership/edit/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAddIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/people/add/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleNewIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/people/new/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesCompanies_houseIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/sources/companies_house/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesFcaIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/sources/fca/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesEditIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/addresses/edit/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksEditIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/checks/edit/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentEditIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/employment/edit/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesFileIdIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/files/$fileId/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/$assessmentId/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityDocumentIdIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/identity/$documentId/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityEditIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/identity/edit/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordEditIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/record/edit/index"
import { Route as OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/reviews/$reviewId/parts/$section/index"
import { Route as OrganisationAuthenticatedOrganisationReviewsReviewIdPeopleAppointmentIdIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/reviews/$reviewId/people/$appointmentId/index"
import { Route as OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationActivitiesIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/settings/organisation/authorisation/activities/index"
import { Route as OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAppointmentIdEndIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/firms/$firmId/people/$appointmentId/end/index"
import { Route as OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdRecordIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/$assessmentId/record/index"
import { Route as OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionDocumentIdIndexRouteImport } from "./routes/$organisation/_authenticated/_organisation/reviews/$reviewId/parts/$section/$documentId/index"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationRouteRoute = OrganisationRouteRouteImport.update({
  id: "/$organisation",
  path: "/$organisation",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const GuestRouteRoute = GuestRouteRouteImport.update({
  id: "/_guest",
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationIndexRoute = OrganisationIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => OrganisationRouteRoute,
} as any)
const OrganisationAuthenticatedRouteRoute =
  OrganisationAuthenticatedRouteRouteImport.update({
    id: "/_authenticated",
    getParentRoute: () => OrganisationRouteRoute,
  } as any)
const OrganisationGuestRouteRoute = OrganisationGuestRouteRouteImport.update({
  id: "/_guest",
  getParentRoute: () => OrganisationRouteRoute,
} as any)
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const OrganisationAuthenticatedOrganisationRouteRoute =
  OrganisationAuthenticatedOrganisationRouteRouteImport.update({
    id: "/_organisation",
    getParentRoute: () => OrganisationAuthenticatedRouteRoute,
  } as any)
const OrganisationPortalPortalRouteRoute =
  OrganisationPortalPortalRouteRouteImport.update({
    id: "/portal/_portal",
    path: "/portal",
    getParentRoute: () => OrganisationRouteRoute,
  } as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const GuestForgotPasswordIndexRoute =
  GuestForgotPasswordIndexRouteImport.update({
    id: "/forgot-password/",
    path: "/forgot-password/",
    getParentRoute: () => GuestRouteRoute,
  } as any)
const GuestLoginIndexRoute = GuestLoginIndexRouteImport.update({
  id: "/login/",
  path: "/login/",
  getParentRoute: () => GuestRouteRoute,
} as any)
const OrganisationAuthenticatedOrganisationMainRouteRoute =
  OrganisationAuthenticatedOrganisationMainRouteRouteImport.update({
    id: "/_main",
    getParentRoute: () => OrganisationAuthenticatedOrganisationRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationSettingsRouteRoute =
  OrganisationAuthenticatedOrganisationSettingsRouteRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => OrganisationAuthenticatedOrganisationRouteRoute,
  } as any)
const OrganisationGuestForgotPasswordIndexRoute =
  OrganisationGuestForgotPasswordIndexRouteImport.update({
    id: "/forgot-password/",
    path: "/forgot-password/",
    getParentRoute: () => OrganisationGuestRouteRoute,
  } as any)
const OrganisationGuestLoginIndexRoute =
  OrganisationGuestLoginIndexRouteImport.update({
    id: "/login/",
    path: "/login/",
    getParentRoute: () => OrganisationGuestRouteRoute,
  } as any)
const OrganisationPortalPortalIndexRoute =
  OrganisationPortalPortalIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => OrganisationPortalPortalRouteRoute,
  } as any)
const OrganisationPortalLoginIndexRoute =
  OrganisationPortalLoginIndexRouteImport.update({
    id: "/portal/login/",
    path: "/portal/login/",
    getParentRoute: () => OrganisationRouteRoute,
  } as any)
const AuthenticatedAdminOrganisationsIndexRoute =
  AuthenticatedAdminOrganisationsIndexRouteImport.update({
    id: "/organisations/",
    path: "/organisations/",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminSettingsIndexRoute =
  AuthenticatedAdminSettingsIndexRouteImport.update({
    id: "/settings/",
    path: "/settings/",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedOrganisationsNoneIndexRoute =
  AuthenticatedOrganisationsNoneIndexRouteImport.update({
    id: "/organisations/none/",
    path: "/organisations/none/",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrganisationsSelectIndexRoute =
  AuthenticatedOrganisationsSelectIndexRouteImport.update({
    id: "/organisations/select/",
    path: "/organisations/select/",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRoute =
  OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRouteImport.update({
    id: "/filings/$filingId",
    path: "/filings/$filingId",
    getParentRoute: () => OrganisationAuthenticatedOrganisationRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRouteImport.update({
    id: "/firms/$firmId",
    path: "/firms/$firmId",
    getParentRoute: () => OrganisationAuthenticatedOrganisationRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRouteImport.update(
    {
      id: "/individuals/$individualId",
      path: "/individuals/$individualId",
      getParentRoute: () => OrganisationAuthenticatedOrganisationRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRoute =
  OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRouteImport.update({
    id: "/issues/$issueId",
    path: "/issues/$issueId",
    getParentRoute: () => OrganisationAuthenticatedOrganisationRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute =
  OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRouteImport.update({
    id: "/reviews/$reviewId",
    path: "/reviews/$reviewId",
    getParentRoute: () => OrganisationAuthenticatedOrganisationRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationSettingsIndexRoute =
  OrganisationAuthenticatedOrganisationSettingsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      OrganisationAuthenticatedOrganisationSettingsRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationTriageIssueIdRouteRoute =
  OrganisationAuthenticatedOrganisationTriageIssueIdRouteRouteImport.update({
    id: "/triage/$issueId",
    path: "/triage/$issueId",
    getParentRoute: () => OrganisationAuthenticatedOrganisationRouteRoute,
  } as any)
const AuthenticatedAdminOrganisationsOrganisationSlugIndexRoute =
  AuthenticatedAdminOrganisationsOrganisationSlugIndexRouteImport.update({
    id: "/organisations/$organisationSlug/",
    path: "/organisations/$organisationSlug/",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminOrganisationsCreateIndexRoute =
  AuthenticatedAdminOrganisationsCreateIndexRouteImport.update({
    id: "/organisations/create/",
    path: "/organisations/create/",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationMainComplianceIndexRoute =
  OrganisationAuthenticatedOrganisationMainComplianceIndexRouteImport.update({
    id: "/compliance/",
    path: "/compliance/",
    getParentRoute: () => OrganisationAuthenticatedOrganisationMainRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationMainDashboardIndexRoute =
  OrganisationAuthenticatedOrganisationMainDashboardIndexRouteImport.update({
    id: "/dashboard/",
    path: "/dashboard/",
    getParentRoute: () => OrganisationAuthenticatedOrganisationMainRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationMainFilingsIndexRoute =
  OrganisationAuthenticatedOrganisationMainFilingsIndexRouteImport.update({
    id: "/filings/",
    path: "/filings/",
    getParentRoute: () => OrganisationAuthenticatedOrganisationMainRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationMainFirmsIndexRoute =
  OrganisationAuthenticatedOrganisationMainFirmsIndexRouteImport.update({
    id: "/firms/",
    path: "/firms/",
    getParentRoute: () => OrganisationAuthenticatedOrganisationMainRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationMainIndividualsIndexRoute =
  OrganisationAuthenticatedOrganisationMainIndividualsIndexRouteImport.update({
    id: "/individuals/",
    path: "/individuals/",
    getParentRoute: () => OrganisationAuthenticatedOrganisationMainRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationMainIssuesIndexRoute =
  OrganisationAuthenticatedOrganisationMainIssuesIndexRouteImport.update({
    id: "/issues/",
    path: "/issues/",
    getParentRoute: () => OrganisationAuthenticatedOrganisationMainRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationMainOversightIndexRoute =
  OrganisationAuthenticatedOrganisationMainOversightIndexRouteImport.update({
    id: "/oversight/",
    path: "/oversight/",
    getParentRoute: () => OrganisationAuthenticatedOrganisationMainRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationMainRequestsIndexRoute =
  OrganisationAuthenticatedOrganisationMainRequestsIndexRouteImport.update({
    id: "/requests/",
    path: "/requests/",
    getParentRoute: () => OrganisationAuthenticatedOrganisationMainRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationMainReviewsIndexRoute =
  OrganisationAuthenticatedOrganisationMainReviewsIndexRouteImport.update({
    id: "/reviews/",
    path: "/reviews/",
    getParentRoute: () => OrganisationAuthenticatedOrganisationMainRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationMainRiskIndexRoute =
  OrganisationAuthenticatedOrganisationMainRiskIndexRouteImport.update({
    id: "/risk/",
    path: "/risk/",
    getParentRoute: () => OrganisationAuthenticatedOrganisationMainRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationMainTasksIndexRoute =
  OrganisationAuthenticatedOrganisationMainTasksIndexRouteImport.update({
    id: "/tasks/",
    path: "/tasks/",
    getParentRoute: () => OrganisationAuthenticatedOrganisationMainRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationMainTriageIndexRoute =
  OrganisationAuthenticatedOrganisationMainTriageIndexRouteImport.update({
    id: "/triage/",
    path: "/triage/",
    getParentRoute: () => OrganisationAuthenticatedOrganisationMainRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationFilingsFilingIdIndexRoute =
  OrganisationAuthenticatedOrganisationFilingsFilingIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationFirmsFirmIdIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdIndexRouteImport.update(
    {
      id: "/",
      path: "/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIssuesIssueIdIndexRoute =
  OrganisationAuthenticatedOrganisationIssuesIssueIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationReviewsReviewIdIndexRoute =
  OrganisationAuthenticatedOrganisationReviewsReviewIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationSettingsProfileIndexRoute =
  OrganisationAuthenticatedOrganisationSettingsProfileIndexRouteImport.update({
    id: "/profile/",
    path: "/profile/",
    getParentRoute: () =>
      OrganisationAuthenticatedOrganisationSettingsRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationTriageIssueIdIndexRoute =
  OrganisationAuthenticatedOrganisationTriageIssueIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      OrganisationAuthenticatedOrganisationTriageIssueIdRouteRoute,
  } as any)
const OrganisationPortalPortalTasksTaskIdIndexRoute =
  OrganisationPortalPortalTasksTaskIdIndexRouteImport.update({
    id: "/tasks/$taskId/",
    path: "/tasks/$taskId/",
    getParentRoute: () => OrganisationPortalPortalRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationMainComplianceGapKeyIndexRoute =
  OrganisationAuthenticatedOrganisationMainComplianceGapKeyIndexRouteImport.update(
    {
      id: "/compliance/$gapKey/",
      path: "/compliance/$gapKey/",
      getParentRoute: () => OrganisationAuthenticatedOrganisationMainRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationMainFirmsCreateIndexRoute =
  OrganisationAuthenticatedOrganisationMainFirmsCreateIndexRouteImport.update({
    id: "/firms/create/",
    path: "/firms/create/",
    getParentRoute: () => OrganisationAuthenticatedOrganisationMainRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationFirmsFirmIdActivityIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdActivityIndexRouteImport.update(
    {
      id: "/activity/",
      path: "/activity/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesIndexRouteImport.update(
    {
      id: "/addresses/",
      path: "/addresses/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementIndexRouteImport.update(
    {
      id: "/agreement/",
      path: "/agreement/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationIndexRouteImport.update(
    {
      id: "/authorisation/",
      path: "/authorisation/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsIndexRouteImport.update(
    {
      id: "/details/",
      path: "/details/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdFilesIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdFilesIndexRouteImport.update({
    id: "/files/",
    path: "/files/",
    getParentRoute: () =>
      OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationFirmsFirmIdFilingsIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdFilingsIndexRouteImport.update(
    {
      id: "/filings/",
      path: "/filings/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdIssuesIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdIssuesIndexRouteImport.update(
    {
      id: "/issues/",
      path: "/issues/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingIndexRouteImport.update(
    {
      id: "/onboarding/",
      path: "/onboarding/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipIndexRouteImport.update(
    {
      id: "/ownership/",
      path: "/ownership/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleIndexRouteImport.update(
    {
      id: "/people/",
      path: "/people/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdReviewsIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdReviewsIndexRouteImport.update(
    {
      id: "/reviews/",
      path: "/reviews/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdRiskIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdRiskIndexRouteImport.update({
    id: "/risk/",
    path: "/risk/",
    getParentRoute: () =>
      OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationFirmsFirmIdScopeIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdScopeIndexRouteImport.update({
    id: "/scope/",
    path: "/scope/",
    getParentRoute: () =>
      OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
  } as any)
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdActivityIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdActivityIndexRouteImport.update(
    {
      id: "/activity/",
      path: "/activity/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesIndexRouteImport.update(
    {
      id: "/addresses/",
      path: "/addresses/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdAppointmentsIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdAppointmentsIndexRouteImport.update(
    {
      id: "/appointments/",
      path: "/appointments/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksIndexRouteImport.update(
    {
      id: "/checks/",
      path: "/checks/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentIndexRouteImport.update(
    {
      id: "/employment/",
      path: "/employment/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesIndexRouteImport.update(
    {
      id: "/files/",
      path: "/files/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessIndexRouteImport.update(
    {
      id: "/fitness/",
      path: "/fitness/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityIndexRouteImport.update(
    {
      id: "/identity/",
      path: "/identity/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdIssuesIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdIssuesIndexRouteImport.update(
    {
      id: "/issues/",
      path: "/issues/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordIndexRouteImport.update(
    {
      id: "/record/",
      path: "/record/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdRegulatoryIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdRegulatoryIndexRouteImport.update(
    {
      id: "/regulatory/",
      path: "/regulatory/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewIndexRouteImport.update(
    {
      id: "/review/",
      path: "/review/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewsIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewsIndexRouteImport.update(
    {
      id: "/reviews/",
      path: "/reviews/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdRiskIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdRiskIndexRouteImport.update(
    {
      id: "/risk/",
      path: "/risk/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationReviewsReviewIdApproveIndexRoute =
  OrganisationAuthenticatedOrganisationReviewsReviewIdApproveIndexRouteImport.update(
    {
      id: "/approve/",
      path: "/approve/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationReviewsReviewIdCancelIndexRoute =
  OrganisationAuthenticatedOrganisationReviewsReviewIdCancelIndexRouteImport.update(
    {
      id: "/cancel/",
      path: "/cancel/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationReviewsReviewIdDueIndexRoute =
  OrganisationAuthenticatedOrganisationReviewsReviewIdDueIndexRouteImport.update(
    {
      id: "/due/",
      path: "/due/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationReviewsReviewIdFirmIndexRoute =
  OrganisationAuthenticatedOrganisationReviewsReviewIdFirmIndexRouteImport.update(
    {
      id: "/firm/",
      path: "/firm/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationSettingsOrganisationActivityIndexRoute =
  OrganisationAuthenticatedOrganisationSettingsOrganisationActivityIndexRouteImport.update(
    {
      id: "/organisation/activity/",
      path: "/organisation/activity/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationSettingsRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationSettingsOrganisationArAgreementsIndexRoute =
  OrganisationAuthenticatedOrganisationSettingsOrganisationArAgreementsIndexRouteImport.update(
    {
      id: "/organisation/ar-agreements/",
      path: "/organisation/ar-agreements/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationSettingsRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationIndexRoute =
  OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationIndexRouteImport.update(
    {
      id: "/organisation/authorisation/",
      path: "/organisation/authorisation/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationSettingsRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationSettingsOrganisationBrandingIndexRoute =
  OrganisationAuthenticatedOrganisationSettingsOrganisationBrandingIndexRouteImport.update(
    {
      id: "/organisation/branding/",
      path: "/organisation/branding/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationSettingsRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationSettingsOrganisationEmailsIndexRoute =
  OrganisationAuthenticatedOrganisationSettingsOrganisationEmailsIndexRouteImport.update(
    {
      id: "/organisation/emails/",
      path: "/organisation/emails/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationSettingsRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationSettingsOrganisationExportIndexRoute =
  OrganisationAuthenticatedOrganisationSettingsOrganisationExportIndexRouteImport.update(
    {
      id: "/organisation/export/",
      path: "/organisation/export/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationSettingsRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationSettingsOrganisationOffboardingIndexRoute =
  OrganisationAuthenticatedOrganisationSettingsOrganisationOffboardingIndexRouteImport.update(
    {
      id: "/organisation/offboarding/",
      path: "/organisation/offboarding/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationSettingsRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationSettingsOrganisationOnboardingIndexRoute =
  OrganisationAuthenticatedOrganisationSettingsOrganisationOnboardingIndexRouteImport.update(
    {
      id: "/organisation/onboarding/",
      path: "/organisation/onboarding/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationSettingsRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationSettingsOrganisationRequirementsIndexRoute =
  OrganisationAuthenticatedOrganisationSettingsOrganisationRequirementsIndexRouteImport.update(
    {
      id: "/organisation/requirements/",
      path: "/organisation/requirements/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationSettingsRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationSettingsOrganisationTeamIndexRoute =
  OrganisationAuthenticatedOrganisationSettingsOrganisationTeamIndexRouteImport.update(
    {
      id: "/organisation/team/",
      path: "/organisation/team/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationSettingsRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationMainRiskFactorsFactorKeyIndexRoute =
  OrganisationAuthenticatedOrganisationMainRiskFactorsFactorKeyIndexRouteImport.update(
    {
      id: "/risk/factors/$factorKey/",
      path: "/risk/factors/$factorKey/",
      getParentRoute: () => OrganisationAuthenticatedOrganisationMainRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesEditIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesEditIndexRouteImport.update(
    {
      id: "/addresses/edit/",
      path: "/addresses/edit/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementAgreementIdIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementAgreementIdIndexRouteImport.update(
    {
      id: "/agreement/$agreementId/",
      path: "/agreement/$agreementId/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationAppointmentIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationAppointmentIndexRouteImport.update(
    {
      id: "/authorisation/appointment/",
      path: "/authorisation/appointment/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsEditIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsEditIndexRouteImport.update(
    {
      id: "/details/edit/",
      path: "/details/edit/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdFilesFileIdIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdFilesFileIdIndexRouteImport.update(
    {
      id: "/files/$fileId/",
      path: "/files/$fileId/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingNewIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingNewIndexRouteImport.update(
    {
      id: "/onboarding/new/",
      path: "/onboarding/new/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipEditIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipEditIndexRouteImport.update(
    {
      id: "/ownership/edit/",
      path: "/ownership/edit/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAddIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAddIndexRouteImport.update(
    {
      id: "/people/add/",
      path: "/people/add/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleNewIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleNewIndexRouteImport.update(
    {
      id: "/people/new/",
      path: "/people/new/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesCompanies_houseIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesCompanies_houseIndexRouteImport.update(
    {
      id: "/sources/companies_house/",
      path: "/sources/companies_house/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesFcaIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesFcaIndexRouteImport.update(
    {
      id: "/sources/fca/",
      path: "/sources/fca/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesEditIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesEditIndexRouteImport.update(
    {
      id: "/addresses/edit/",
      path: "/addresses/edit/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksEditIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksEditIndexRouteImport.update(
    {
      id: "/checks/edit/",
      path: "/checks/edit/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentEditIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentEditIndexRouteImport.update(
    {
      id: "/employment/edit/",
      path: "/employment/edit/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesFileIdIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesFileIdIndexRouteImport.update(
    {
      id: "/files/$fileId/",
      path: "/files/$fileId/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdIndexRouteImport.update(
    {
      id: "/fitness/$assessmentId/",
      path: "/fitness/$assessmentId/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityDocumentIdIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityDocumentIdIndexRouteImport.update(
    {
      id: "/identity/$documentId/",
      path: "/identity/$documentId/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityEditIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityEditIndexRouteImport.update(
    {
      id: "/identity/edit/",
      path: "/identity/edit/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordEditIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordEditIndexRouteImport.update(
    {
      id: "/record/edit/",
      path: "/record/edit/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionIndexRoute =
  OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionIndexRouteImport.update(
    {
      id: "/parts/$section/",
      path: "/parts/$section/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationReviewsReviewIdPeopleAppointmentIdIndexRoute =
  OrganisationAuthenticatedOrganisationReviewsReviewIdPeopleAppointmentIdIndexRouteImport.update(
    {
      id: "/people/$appointmentId/",
      path: "/people/$appointmentId/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationActivitiesIndexRoute =
  OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationActivitiesIndexRouteImport.update(
    {
      id: "/organisation/authorisation/activities/",
      path: "/organisation/authorisation/activities/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationSettingsRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAppointmentIdEndIndexRoute =
  OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAppointmentIdEndIndexRouteImport.update(
    {
      id: "/people/$appointmentId/end/",
      path: "/people/$appointmentId/end/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdRecordIndexRoute =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdRecordIndexRouteImport.update(
    {
      id: "/fitness/$assessmentId/record/",
      path: "/fitness/$assessmentId/record/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute,
    } as any,
  )
const OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionDocumentIdIndexRoute =
  OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionDocumentIdIndexRouteImport.update(
    {
      id: "/parts/$section/$documentId/",
      path: "/parts/$section/$documentId/",
      getParentRoute: () =>
        OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/$organisation": typeof OrganisationRouteRouteWithChildren
  "/admin": typeof AuthenticatedAdminRouteRouteWithChildren
  "/$organisation/": typeof OrganisationIndexRoute
  "/$organisation/portal": typeof OrganisationPortalPortalRouteRouteWithChildren
  "/admin/": typeof AuthenticatedAdminIndexRoute
  "/forgot-password/": typeof GuestForgotPasswordIndexRoute
  "/login/": typeof GuestLoginIndexRoute
  "/$organisation/settings": typeof OrganisationAuthenticatedOrganisationSettingsRouteRouteWithChildren
  "/$organisation/forgot-password/": typeof OrganisationGuestForgotPasswordIndexRoute
  "/$organisation/login/": typeof OrganisationGuestLoginIndexRoute
  "/$organisation/portal/": typeof OrganisationPortalPortalIndexRoute
  "/$organisation/portal/login/": typeof OrganisationPortalLoginIndexRoute
  "/admin/organisations/": typeof AuthenticatedAdminOrganisationsIndexRoute
  "/admin/settings/": typeof AuthenticatedAdminSettingsIndexRoute
  "/organisations/none/": typeof AuthenticatedOrganisationsNoneIndexRoute
  "/organisations/select/": typeof AuthenticatedOrganisationsSelectIndexRoute
  "/$organisation/filings/$filingId": typeof OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRouteWithChildren
  "/$organisation/firms/$firmId": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRouteWithChildren
  "/$organisation/individuals/$individualId": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRouteWithChildren
  "/$organisation/issues/$issueId": typeof OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRouteWithChildren
  "/$organisation/reviews/$reviewId": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRouteWithChildren
  "/$organisation/triage/$issueId": typeof OrganisationAuthenticatedOrganisationTriageIssueIdRouteRouteWithChildren
  "/$organisation/settings/": typeof OrganisationAuthenticatedOrganisationSettingsIndexRoute
  "/admin/organisations/$organisationSlug/": typeof AuthenticatedAdminOrganisationsOrganisationSlugIndexRoute
  "/admin/organisations/create/": typeof AuthenticatedAdminOrganisationsCreateIndexRoute
  "/$organisation/compliance/": typeof OrganisationAuthenticatedOrganisationMainComplianceIndexRoute
  "/$organisation/dashboard/": typeof OrganisationAuthenticatedOrganisationMainDashboardIndexRoute
  "/$organisation/filings/": typeof OrganisationAuthenticatedOrganisationMainFilingsIndexRoute
  "/$organisation/firms/": typeof OrganisationAuthenticatedOrganisationMainFirmsIndexRoute
  "/$organisation/individuals/": typeof OrganisationAuthenticatedOrganisationMainIndividualsIndexRoute
  "/$organisation/issues/": typeof OrganisationAuthenticatedOrganisationMainIssuesIndexRoute
  "/$organisation/oversight/": typeof OrganisationAuthenticatedOrganisationMainOversightIndexRoute
  "/$organisation/requests/": typeof OrganisationAuthenticatedOrganisationMainRequestsIndexRoute
  "/$organisation/reviews/": typeof OrganisationAuthenticatedOrganisationMainReviewsIndexRoute
  "/$organisation/risk/": typeof OrganisationAuthenticatedOrganisationMainRiskIndexRoute
  "/$organisation/tasks/": typeof OrganisationAuthenticatedOrganisationMainTasksIndexRoute
  "/$organisation/triage/": typeof OrganisationAuthenticatedOrganisationMainTriageIndexRoute
  "/$organisation/filings/$filingId/": typeof OrganisationAuthenticatedOrganisationFilingsFilingIdIndexRoute
  "/$organisation/firms/$firmId/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdIndexRoute
  "/$organisation/individuals/$individualId/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIndexRoute
  "/$organisation/issues/$issueId/": typeof OrganisationAuthenticatedOrganisationIssuesIssueIdIndexRoute
  "/$organisation/reviews/$reviewId/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdIndexRoute
  "/$organisation/settings/profile/": typeof OrganisationAuthenticatedOrganisationSettingsProfileIndexRoute
  "/$organisation/triage/$issueId/": typeof OrganisationAuthenticatedOrganisationTriageIssueIdIndexRoute
  "/$organisation/portal/tasks/$taskId/": typeof OrganisationPortalPortalTasksTaskIdIndexRoute
  "/$organisation/compliance/$gapKey/": typeof OrganisationAuthenticatedOrganisationMainComplianceGapKeyIndexRoute
  "/$organisation/firms/create/": typeof OrganisationAuthenticatedOrganisationMainFirmsCreateIndexRoute
  "/$organisation/firms/$firmId/activity/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdActivityIndexRoute
  "/$organisation/firms/$firmId/addresses/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesIndexRoute
  "/$organisation/firms/$firmId/agreement/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementIndexRoute
  "/$organisation/firms/$firmId/authorisation/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationIndexRoute
  "/$organisation/firms/$firmId/details/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsIndexRoute
  "/$organisation/firms/$firmId/files/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdFilesIndexRoute
  "/$organisation/firms/$firmId/filings/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdFilingsIndexRoute
  "/$organisation/firms/$firmId/issues/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdIssuesIndexRoute
  "/$organisation/firms/$firmId/onboarding/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingIndexRoute
  "/$organisation/firms/$firmId/ownership/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipIndexRoute
  "/$organisation/firms/$firmId/people/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleIndexRoute
  "/$organisation/firms/$firmId/reviews/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdReviewsIndexRoute
  "/$organisation/firms/$firmId/risk/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRiskIndexRoute
  "/$organisation/firms/$firmId/scope/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdScopeIndexRoute
  "/$organisation/individuals/$individualId/activity/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdActivityIndexRoute
  "/$organisation/individuals/$individualId/addresses/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesIndexRoute
  "/$organisation/individuals/$individualId/appointments/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdAppointmentsIndexRoute
  "/$organisation/individuals/$individualId/checks/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksIndexRoute
  "/$organisation/individuals/$individualId/employment/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentIndexRoute
  "/$organisation/individuals/$individualId/files/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesIndexRoute
  "/$organisation/individuals/$individualId/fitness/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessIndexRoute
  "/$organisation/individuals/$individualId/identity/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityIndexRoute
  "/$organisation/individuals/$individualId/issues/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIssuesIndexRoute
  "/$organisation/individuals/$individualId/record/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordIndexRoute
  "/$organisation/individuals/$individualId/regulatory/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRegulatoryIndexRoute
  "/$organisation/individuals/$individualId/review/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewIndexRoute
  "/$organisation/individuals/$individualId/reviews/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewsIndexRoute
  "/$organisation/individuals/$individualId/risk/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRiskIndexRoute
  "/$organisation/reviews/$reviewId/approve/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdApproveIndexRoute
  "/$organisation/reviews/$reviewId/cancel/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdCancelIndexRoute
  "/$organisation/reviews/$reviewId/due/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdDueIndexRoute
  "/$organisation/reviews/$reviewId/firm/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdFirmIndexRoute
  "/$organisation/settings/organisation/activity/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationActivityIndexRoute
  "/$organisation/settings/organisation/ar-agreements/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationArAgreementsIndexRoute
  "/$organisation/settings/organisation/authorisation/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationIndexRoute
  "/$organisation/settings/organisation/branding/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationBrandingIndexRoute
  "/$organisation/settings/organisation/emails/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationEmailsIndexRoute
  "/$organisation/settings/organisation/export/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationExportIndexRoute
  "/$organisation/settings/organisation/offboarding/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationOffboardingIndexRoute
  "/$organisation/settings/organisation/onboarding/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationOnboardingIndexRoute
  "/$organisation/settings/organisation/requirements/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationRequirementsIndexRoute
  "/$organisation/settings/organisation/team/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationTeamIndexRoute
  "/$organisation/risk/factors/$factorKey/": typeof OrganisationAuthenticatedOrganisationMainRiskFactorsFactorKeyIndexRoute
  "/$organisation/firms/$firmId/addresses/edit/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesEditIndexRoute
  "/$organisation/firms/$firmId/agreement/$agreementId/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementAgreementIdIndexRoute
  "/$organisation/firms/$firmId/authorisation/appointment/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationAppointmentIndexRoute
  "/$organisation/firms/$firmId/details/edit/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsEditIndexRoute
  "/$organisation/firms/$firmId/files/$fileId/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdFilesFileIdIndexRoute
  "/$organisation/firms/$firmId/onboarding/new/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingNewIndexRoute
  "/$organisation/firms/$firmId/ownership/edit/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipEditIndexRoute
  "/$organisation/firms/$firmId/people/add/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAddIndexRoute
  "/$organisation/firms/$firmId/people/new/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleNewIndexRoute
  "/$organisation/firms/$firmId/sources/companies_house/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesCompanies_houseIndexRoute
  "/$organisation/firms/$firmId/sources/fca/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesFcaIndexRoute
  "/$organisation/individuals/$individualId/addresses/edit/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesEditIndexRoute
  "/$organisation/individuals/$individualId/checks/edit/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksEditIndexRoute
  "/$organisation/individuals/$individualId/employment/edit/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentEditIndexRoute
  "/$organisation/individuals/$individualId/files/$fileId/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesFileIdIndexRoute
  "/$organisation/individuals/$individualId/fitness/$assessmentId/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdIndexRoute
  "/$organisation/individuals/$individualId/identity/$documentId/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityDocumentIdIndexRoute
  "/$organisation/individuals/$individualId/identity/edit/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityEditIndexRoute
  "/$organisation/individuals/$individualId/record/edit/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordEditIndexRoute
  "/$organisation/reviews/$reviewId/parts/$section/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionIndexRoute
  "/$organisation/reviews/$reviewId/people/$appointmentId/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdPeopleAppointmentIdIndexRoute
  "/$organisation/settings/organisation/authorisation/activities/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationActivitiesIndexRoute
  "/$organisation/firms/$firmId/people/$appointmentId/end/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAppointmentIdEndIndexRoute
  "/$organisation/individuals/$individualId/fitness/$assessmentId/record/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdRecordIndexRoute
  "/$organisation/reviews/$reviewId/parts/$section/$documentId/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionDocumentIdIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/$organisation": typeof OrganisationIndexRoute
  "/admin": typeof AuthenticatedAdminIndexRoute
  "/forgot-password": typeof GuestForgotPasswordIndexRoute
  "/login": typeof GuestLoginIndexRoute
  "/$organisation/forgot-password": typeof OrganisationGuestForgotPasswordIndexRoute
  "/$organisation/login": typeof OrganisationGuestLoginIndexRoute
  "/$organisation/portal": typeof OrganisationPortalPortalIndexRoute
  "/$organisation/portal/login": typeof OrganisationPortalLoginIndexRoute
  "/admin/organisations": typeof AuthenticatedAdminOrganisationsIndexRoute
  "/admin/settings": typeof AuthenticatedAdminSettingsIndexRoute
  "/organisations/none": typeof AuthenticatedOrganisationsNoneIndexRoute
  "/organisations/select": typeof AuthenticatedOrganisationsSelectIndexRoute
  "/$organisation/settings": typeof OrganisationAuthenticatedOrganisationSettingsIndexRoute
  "/admin/organisations/$organisationSlug": typeof AuthenticatedAdminOrganisationsOrganisationSlugIndexRoute
  "/admin/organisations/create": typeof AuthenticatedAdminOrganisationsCreateIndexRoute
  "/$organisation/compliance": typeof OrganisationAuthenticatedOrganisationMainComplianceIndexRoute
  "/$organisation/dashboard": typeof OrganisationAuthenticatedOrganisationMainDashboardIndexRoute
  "/$organisation/filings": typeof OrganisationAuthenticatedOrganisationMainFilingsIndexRoute
  "/$organisation/firms": typeof OrganisationAuthenticatedOrganisationMainFirmsIndexRoute
  "/$organisation/individuals": typeof OrganisationAuthenticatedOrganisationMainIndividualsIndexRoute
  "/$organisation/issues": typeof OrganisationAuthenticatedOrganisationMainIssuesIndexRoute
  "/$organisation/oversight": typeof OrganisationAuthenticatedOrganisationMainOversightIndexRoute
  "/$organisation/requests": typeof OrganisationAuthenticatedOrganisationMainRequestsIndexRoute
  "/$organisation/reviews": typeof OrganisationAuthenticatedOrganisationMainReviewsIndexRoute
  "/$organisation/risk": typeof OrganisationAuthenticatedOrganisationMainRiskIndexRoute
  "/$organisation/tasks": typeof OrganisationAuthenticatedOrganisationMainTasksIndexRoute
  "/$organisation/triage": typeof OrganisationAuthenticatedOrganisationMainTriageIndexRoute
  "/$organisation/filings/$filingId": typeof OrganisationAuthenticatedOrganisationFilingsFilingIdIndexRoute
  "/$organisation/firms/$firmId": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdIndexRoute
  "/$organisation/individuals/$individualId": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIndexRoute
  "/$organisation/issues/$issueId": typeof OrganisationAuthenticatedOrganisationIssuesIssueIdIndexRoute
  "/$organisation/reviews/$reviewId": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdIndexRoute
  "/$organisation/settings/profile": typeof OrganisationAuthenticatedOrganisationSettingsProfileIndexRoute
  "/$organisation/triage/$issueId": typeof OrganisationAuthenticatedOrganisationTriageIssueIdIndexRoute
  "/$organisation/portal/tasks/$taskId": typeof OrganisationPortalPortalTasksTaskIdIndexRoute
  "/$organisation/compliance/$gapKey": typeof OrganisationAuthenticatedOrganisationMainComplianceGapKeyIndexRoute
  "/$organisation/firms/create": typeof OrganisationAuthenticatedOrganisationMainFirmsCreateIndexRoute
  "/$organisation/firms/$firmId/activity": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdActivityIndexRoute
  "/$organisation/firms/$firmId/addresses": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesIndexRoute
  "/$organisation/firms/$firmId/agreement": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementIndexRoute
  "/$organisation/firms/$firmId/authorisation": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationIndexRoute
  "/$organisation/firms/$firmId/details": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsIndexRoute
  "/$organisation/firms/$firmId/files": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdFilesIndexRoute
  "/$organisation/firms/$firmId/filings": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdFilingsIndexRoute
  "/$organisation/firms/$firmId/issues": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdIssuesIndexRoute
  "/$organisation/firms/$firmId/onboarding": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingIndexRoute
  "/$organisation/firms/$firmId/ownership": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipIndexRoute
  "/$organisation/firms/$firmId/people": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleIndexRoute
  "/$organisation/firms/$firmId/reviews": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdReviewsIndexRoute
  "/$organisation/firms/$firmId/risk": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRiskIndexRoute
  "/$organisation/firms/$firmId/scope": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdScopeIndexRoute
  "/$organisation/individuals/$individualId/activity": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdActivityIndexRoute
  "/$organisation/individuals/$individualId/addresses": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesIndexRoute
  "/$organisation/individuals/$individualId/appointments": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdAppointmentsIndexRoute
  "/$organisation/individuals/$individualId/checks": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksIndexRoute
  "/$organisation/individuals/$individualId/employment": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentIndexRoute
  "/$organisation/individuals/$individualId/files": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesIndexRoute
  "/$organisation/individuals/$individualId/fitness": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessIndexRoute
  "/$organisation/individuals/$individualId/identity": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityIndexRoute
  "/$organisation/individuals/$individualId/issues": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIssuesIndexRoute
  "/$organisation/individuals/$individualId/record": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordIndexRoute
  "/$organisation/individuals/$individualId/regulatory": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRegulatoryIndexRoute
  "/$organisation/individuals/$individualId/review": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewIndexRoute
  "/$organisation/individuals/$individualId/reviews": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewsIndexRoute
  "/$organisation/individuals/$individualId/risk": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRiskIndexRoute
  "/$organisation/reviews/$reviewId/approve": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdApproveIndexRoute
  "/$organisation/reviews/$reviewId/cancel": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdCancelIndexRoute
  "/$organisation/reviews/$reviewId/due": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdDueIndexRoute
  "/$organisation/reviews/$reviewId/firm": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdFirmIndexRoute
  "/$organisation/settings/organisation/activity": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationActivityIndexRoute
  "/$organisation/settings/organisation/ar-agreements": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationArAgreementsIndexRoute
  "/$organisation/settings/organisation/authorisation": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationIndexRoute
  "/$organisation/settings/organisation/branding": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationBrandingIndexRoute
  "/$organisation/settings/organisation/emails": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationEmailsIndexRoute
  "/$organisation/settings/organisation/export": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationExportIndexRoute
  "/$organisation/settings/organisation/offboarding": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationOffboardingIndexRoute
  "/$organisation/settings/organisation/onboarding": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationOnboardingIndexRoute
  "/$organisation/settings/organisation/requirements": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationRequirementsIndexRoute
  "/$organisation/settings/organisation/team": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationTeamIndexRoute
  "/$organisation/risk/factors/$factorKey": typeof OrganisationAuthenticatedOrganisationMainRiskFactorsFactorKeyIndexRoute
  "/$organisation/firms/$firmId/addresses/edit": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesEditIndexRoute
  "/$organisation/firms/$firmId/agreement/$agreementId": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementAgreementIdIndexRoute
  "/$organisation/firms/$firmId/authorisation/appointment": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationAppointmentIndexRoute
  "/$organisation/firms/$firmId/details/edit": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsEditIndexRoute
  "/$organisation/firms/$firmId/files/$fileId": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdFilesFileIdIndexRoute
  "/$organisation/firms/$firmId/onboarding/new": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingNewIndexRoute
  "/$organisation/firms/$firmId/ownership/edit": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipEditIndexRoute
  "/$organisation/firms/$firmId/people/add": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAddIndexRoute
  "/$organisation/firms/$firmId/people/new": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleNewIndexRoute
  "/$organisation/firms/$firmId/sources/companies_house": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesCompanies_houseIndexRoute
  "/$organisation/firms/$firmId/sources/fca": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesFcaIndexRoute
  "/$organisation/individuals/$individualId/addresses/edit": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesEditIndexRoute
  "/$organisation/individuals/$individualId/checks/edit": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksEditIndexRoute
  "/$organisation/individuals/$individualId/employment/edit": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentEditIndexRoute
  "/$organisation/individuals/$individualId/files/$fileId": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesFileIdIndexRoute
  "/$organisation/individuals/$individualId/fitness/$assessmentId": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdIndexRoute
  "/$organisation/individuals/$individualId/identity/$documentId": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityDocumentIdIndexRoute
  "/$organisation/individuals/$individualId/identity/edit": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityEditIndexRoute
  "/$organisation/individuals/$individualId/record/edit": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordEditIndexRoute
  "/$organisation/reviews/$reviewId/parts/$section": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionIndexRoute
  "/$organisation/reviews/$reviewId/people/$appointmentId": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdPeopleAppointmentIdIndexRoute
  "/$organisation/settings/organisation/authorisation/activities": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationActivitiesIndexRoute
  "/$organisation/firms/$firmId/people/$appointmentId/end": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAppointmentIdEndIndexRoute
  "/$organisation/individuals/$individualId/fitness/$assessmentId/record": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdRecordIndexRoute
  "/$organisation/reviews/$reviewId/parts/$section/$documentId": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionDocumentIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/$organisation": typeof OrganisationRouteRouteWithChildren
  "/_authenticated": typeof AuthenticatedRouteRouteWithChildren
  "/_guest": typeof GuestRouteRouteWithChildren
  "/$organisation/_authenticated": typeof OrganisationAuthenticatedRouteRouteWithChildren
  "/$organisation/_guest": typeof OrganisationGuestRouteRouteWithChildren
  "/_authenticated/admin": typeof AuthenticatedAdminRouteRouteWithChildren
  "/$organisation/": typeof OrganisationIndexRoute
  "/$organisation/_authenticated/_organisation": typeof OrganisationAuthenticatedOrganisationRouteRouteWithChildren
  "/$organisation/portal/_portal": typeof OrganisationPortalPortalRouteRouteWithChildren
  "/_authenticated/admin/": typeof AuthenticatedAdminIndexRoute
  "/_guest/forgot-password/": typeof GuestForgotPasswordIndexRoute
  "/_guest/login/": typeof GuestLoginIndexRoute
  "/$organisation/_authenticated/_organisation/_main": typeof OrganisationAuthenticatedOrganisationMainRouteRouteWithChildren
  "/$organisation/_authenticated/_organisation/settings": typeof OrganisationAuthenticatedOrganisationSettingsRouteRouteWithChildren
  "/$organisation/_guest/forgot-password/": typeof OrganisationGuestForgotPasswordIndexRoute
  "/$organisation/_guest/login/": typeof OrganisationGuestLoginIndexRoute
  "/$organisation/portal/_portal/": typeof OrganisationPortalPortalIndexRoute
  "/$organisation/portal/login/": typeof OrganisationPortalLoginIndexRoute
  "/_authenticated/admin/organisations/": typeof AuthenticatedAdminOrganisationsIndexRoute
  "/_authenticated/admin/settings/": typeof AuthenticatedAdminSettingsIndexRoute
  "/_authenticated/organisations/none/": typeof AuthenticatedOrganisationsNoneIndexRoute
  "/_authenticated/organisations/select/": typeof AuthenticatedOrganisationsSelectIndexRoute
  "/$organisation/_authenticated/_organisation/filings/$filingId": typeof OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRouteWithChildren
  "/$organisation/_authenticated/_organisation/firms/$firmId": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRouteWithChildren
  "/$organisation/_authenticated/_organisation/individuals/$individualId": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRouteWithChildren
  "/$organisation/_authenticated/_organisation/issues/$issueId": typeof OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRouteWithChildren
  "/$organisation/_authenticated/_organisation/reviews/$reviewId": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRouteWithChildren
  "/$organisation/_authenticated/_organisation/triage/$issueId": typeof OrganisationAuthenticatedOrganisationTriageIssueIdRouteRouteWithChildren
  "/$organisation/_authenticated/_organisation/settings/": typeof OrganisationAuthenticatedOrganisationSettingsIndexRoute
  "/_authenticated/admin/organisations/$organisationSlug/": typeof AuthenticatedAdminOrganisationsOrganisationSlugIndexRoute
  "/_authenticated/admin/organisations/create/": typeof AuthenticatedAdminOrganisationsCreateIndexRoute
  "/$organisation/_authenticated/_organisation/_main/compliance/": typeof OrganisationAuthenticatedOrganisationMainComplianceIndexRoute
  "/$organisation/_authenticated/_organisation/_main/dashboard/": typeof OrganisationAuthenticatedOrganisationMainDashboardIndexRoute
  "/$organisation/_authenticated/_organisation/_main/filings/": typeof OrganisationAuthenticatedOrganisationMainFilingsIndexRoute
  "/$organisation/_authenticated/_organisation/_main/firms/": typeof OrganisationAuthenticatedOrganisationMainFirmsIndexRoute
  "/$organisation/_authenticated/_organisation/_main/individuals/": typeof OrganisationAuthenticatedOrganisationMainIndividualsIndexRoute
  "/$organisation/_authenticated/_organisation/_main/issues/": typeof OrganisationAuthenticatedOrganisationMainIssuesIndexRoute
  "/$organisation/_authenticated/_organisation/_main/oversight/": typeof OrganisationAuthenticatedOrganisationMainOversightIndexRoute
  "/$organisation/_authenticated/_organisation/_main/requests/": typeof OrganisationAuthenticatedOrganisationMainRequestsIndexRoute
  "/$organisation/_authenticated/_organisation/_main/reviews/": typeof OrganisationAuthenticatedOrganisationMainReviewsIndexRoute
  "/$organisation/_authenticated/_organisation/_main/risk/": typeof OrganisationAuthenticatedOrganisationMainRiskIndexRoute
  "/$organisation/_authenticated/_organisation/_main/tasks/": typeof OrganisationAuthenticatedOrganisationMainTasksIndexRoute
  "/$organisation/_authenticated/_organisation/_main/triage/": typeof OrganisationAuthenticatedOrganisationMainTriageIndexRoute
  "/$organisation/_authenticated/_organisation/filings/$filingId/": typeof OrganisationAuthenticatedOrganisationFilingsFilingIdIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIndexRoute
  "/$organisation/_authenticated/_organisation/issues/$issueId/": typeof OrganisationAuthenticatedOrganisationIssuesIssueIdIndexRoute
  "/$organisation/_authenticated/_organisation/reviews/$reviewId/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdIndexRoute
  "/$organisation/_authenticated/_organisation/settings/profile/": typeof OrganisationAuthenticatedOrganisationSettingsProfileIndexRoute
  "/$organisation/_authenticated/_organisation/triage/$issueId/": typeof OrganisationAuthenticatedOrganisationTriageIssueIdIndexRoute
  "/$organisation/portal/_portal/tasks/$taskId/": typeof OrganisationPortalPortalTasksTaskIdIndexRoute
  "/$organisation/_authenticated/_organisation/_main/compliance/$gapKey/": typeof OrganisationAuthenticatedOrganisationMainComplianceGapKeyIndexRoute
  "/$organisation/_authenticated/_organisation/_main/firms/create/": typeof OrganisationAuthenticatedOrganisationMainFirmsCreateIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/activity/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdActivityIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/addresses/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/agreement/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/authorisation/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/details/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/files/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdFilesIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/filings/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdFilingsIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/issues/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdIssuesIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/onboarding/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/ownership/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/people/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/reviews/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdReviewsIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/risk/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRiskIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/scope/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdScopeIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/activity/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdActivityIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/addresses/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/appointments/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdAppointmentsIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/checks/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/employment/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/files/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/identity/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/issues/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIssuesIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/record/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/regulatory/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRegulatoryIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/review/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/reviews/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewsIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/risk/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRiskIndexRoute
  "/$organisation/_authenticated/_organisation/reviews/$reviewId/approve/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdApproveIndexRoute
  "/$organisation/_authenticated/_organisation/reviews/$reviewId/cancel/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdCancelIndexRoute
  "/$organisation/_authenticated/_organisation/reviews/$reviewId/due/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdDueIndexRoute
  "/$organisation/_authenticated/_organisation/reviews/$reviewId/firm/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdFirmIndexRoute
  "/$organisation/_authenticated/_organisation/settings/organisation/activity/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationActivityIndexRoute
  "/$organisation/_authenticated/_organisation/settings/organisation/ar-agreements/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationArAgreementsIndexRoute
  "/$organisation/_authenticated/_organisation/settings/organisation/authorisation/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationIndexRoute
  "/$organisation/_authenticated/_organisation/settings/organisation/branding/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationBrandingIndexRoute
  "/$organisation/_authenticated/_organisation/settings/organisation/emails/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationEmailsIndexRoute
  "/$organisation/_authenticated/_organisation/settings/organisation/export/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationExportIndexRoute
  "/$organisation/_authenticated/_organisation/settings/organisation/offboarding/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationOffboardingIndexRoute
  "/$organisation/_authenticated/_organisation/settings/organisation/onboarding/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationOnboardingIndexRoute
  "/$organisation/_authenticated/_organisation/settings/organisation/requirements/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationRequirementsIndexRoute
  "/$organisation/_authenticated/_organisation/settings/organisation/team/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationTeamIndexRoute
  "/$organisation/_authenticated/_organisation/_main/risk/factors/$factorKey/": typeof OrganisationAuthenticatedOrganisationMainRiskFactorsFactorKeyIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/addresses/edit/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesEditIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/agreement/$agreementId/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementAgreementIdIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/authorisation/appointment/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationAppointmentIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/details/edit/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsEditIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/files/$fileId/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdFilesFileIdIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/onboarding/new/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingNewIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/ownership/edit/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipEditIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/people/add/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAddIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/people/new/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleNewIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/sources/companies_house/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesCompanies_houseIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/sources/fca/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesFcaIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/addresses/edit/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesEditIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/checks/edit/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksEditIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/employment/edit/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentEditIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/files/$fileId/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesFileIdIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/$assessmentId/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/identity/$documentId/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityDocumentIdIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/identity/edit/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityEditIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/record/edit/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordEditIndexRoute
  "/$organisation/_authenticated/_organisation/reviews/$reviewId/parts/$section/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionIndexRoute
  "/$organisation/_authenticated/_organisation/reviews/$reviewId/people/$appointmentId/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdPeopleAppointmentIdIndexRoute
  "/$organisation/_authenticated/_organisation/settings/organisation/authorisation/activities/": typeof OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationActivitiesIndexRoute
  "/$organisation/_authenticated/_organisation/firms/$firmId/people/$appointmentId/end/": typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAppointmentIdEndIndexRoute
  "/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/$assessmentId/record/": typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdRecordIndexRoute
  "/$organisation/_authenticated/_organisation/reviews/$reviewId/parts/$section/$documentId/": typeof OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionDocumentIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/$organisation"
    | "/admin"
    | "/$organisation/"
    | "/$organisation/portal"
    | "/admin/"
    | "/forgot-password/"
    | "/login/"
    | "/$organisation/settings"
    | "/$organisation/forgot-password/"
    | "/$organisation/login/"
    | "/$organisation/portal/"
    | "/$organisation/portal/login/"
    | "/admin/organisations/"
    | "/admin/settings/"
    | "/organisations/none/"
    | "/organisations/select/"
    | "/$organisation/filings/$filingId"
    | "/$organisation/firms/$firmId"
    | "/$organisation/individuals/$individualId"
    | "/$organisation/issues/$issueId"
    | "/$organisation/reviews/$reviewId"
    | "/$organisation/triage/$issueId"
    | "/$organisation/settings/"
    | "/admin/organisations/$organisationSlug/"
    | "/admin/organisations/create/"
    | "/$organisation/compliance/"
    | "/$organisation/dashboard/"
    | "/$organisation/filings/"
    | "/$organisation/firms/"
    | "/$organisation/individuals/"
    | "/$organisation/issues/"
    | "/$organisation/oversight/"
    | "/$organisation/requests/"
    | "/$organisation/reviews/"
    | "/$organisation/risk/"
    | "/$organisation/tasks/"
    | "/$organisation/triage/"
    | "/$organisation/filings/$filingId/"
    | "/$organisation/firms/$firmId/"
    | "/$organisation/individuals/$individualId/"
    | "/$organisation/issues/$issueId/"
    | "/$organisation/reviews/$reviewId/"
    | "/$organisation/settings/profile/"
    | "/$organisation/triage/$issueId/"
    | "/$organisation/portal/tasks/$taskId/"
    | "/$organisation/compliance/$gapKey/"
    | "/$organisation/firms/create/"
    | "/$organisation/firms/$firmId/activity/"
    | "/$organisation/firms/$firmId/addresses/"
    | "/$organisation/firms/$firmId/agreement/"
    | "/$organisation/firms/$firmId/authorisation/"
    | "/$organisation/firms/$firmId/details/"
    | "/$organisation/firms/$firmId/files/"
    | "/$organisation/firms/$firmId/filings/"
    | "/$organisation/firms/$firmId/issues/"
    | "/$organisation/firms/$firmId/onboarding/"
    | "/$organisation/firms/$firmId/ownership/"
    | "/$organisation/firms/$firmId/people/"
    | "/$organisation/firms/$firmId/reviews/"
    | "/$organisation/firms/$firmId/risk/"
    | "/$organisation/firms/$firmId/scope/"
    | "/$organisation/individuals/$individualId/activity/"
    | "/$organisation/individuals/$individualId/addresses/"
    | "/$organisation/individuals/$individualId/appointments/"
    | "/$organisation/individuals/$individualId/checks/"
    | "/$organisation/individuals/$individualId/employment/"
    | "/$organisation/individuals/$individualId/files/"
    | "/$organisation/individuals/$individualId/fitness/"
    | "/$organisation/individuals/$individualId/identity/"
    | "/$organisation/individuals/$individualId/issues/"
    | "/$organisation/individuals/$individualId/record/"
    | "/$organisation/individuals/$individualId/regulatory/"
    | "/$organisation/individuals/$individualId/review/"
    | "/$organisation/individuals/$individualId/reviews/"
    | "/$organisation/individuals/$individualId/risk/"
    | "/$organisation/reviews/$reviewId/approve/"
    | "/$organisation/reviews/$reviewId/cancel/"
    | "/$organisation/reviews/$reviewId/due/"
    | "/$organisation/reviews/$reviewId/firm/"
    | "/$organisation/settings/organisation/activity/"
    | "/$organisation/settings/organisation/ar-agreements/"
    | "/$organisation/settings/organisation/authorisation/"
    | "/$organisation/settings/organisation/branding/"
    | "/$organisation/settings/organisation/emails/"
    | "/$organisation/settings/organisation/export/"
    | "/$organisation/settings/organisation/offboarding/"
    | "/$organisation/settings/organisation/onboarding/"
    | "/$organisation/settings/organisation/requirements/"
    | "/$organisation/settings/organisation/team/"
    | "/$organisation/risk/factors/$factorKey/"
    | "/$organisation/firms/$firmId/addresses/edit/"
    | "/$organisation/firms/$firmId/agreement/$agreementId/"
    | "/$organisation/firms/$firmId/authorisation/appointment/"
    | "/$organisation/firms/$firmId/details/edit/"
    | "/$organisation/firms/$firmId/files/$fileId/"
    | "/$organisation/firms/$firmId/onboarding/new/"
    | "/$organisation/firms/$firmId/ownership/edit/"
    | "/$organisation/firms/$firmId/people/add/"
    | "/$organisation/firms/$firmId/people/new/"
    | "/$organisation/firms/$firmId/sources/companies_house/"
    | "/$organisation/firms/$firmId/sources/fca/"
    | "/$organisation/individuals/$individualId/addresses/edit/"
    | "/$organisation/individuals/$individualId/checks/edit/"
    | "/$organisation/individuals/$individualId/employment/edit/"
    | "/$organisation/individuals/$individualId/files/$fileId/"
    | "/$organisation/individuals/$individualId/fitness/$assessmentId/"
    | "/$organisation/individuals/$individualId/identity/$documentId/"
    | "/$organisation/individuals/$individualId/identity/edit/"
    | "/$organisation/individuals/$individualId/record/edit/"
    | "/$organisation/reviews/$reviewId/parts/$section/"
    | "/$organisation/reviews/$reviewId/people/$appointmentId/"
    | "/$organisation/settings/organisation/authorisation/activities/"
    | "/$organisation/firms/$firmId/people/$appointmentId/end/"
    | "/$organisation/individuals/$individualId/fitness/$assessmentId/record/"
    | "/$organisation/reviews/$reviewId/parts/$section/$documentId/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/$organisation"
    | "/admin"
    | "/forgot-password"
    | "/login"
    | "/$organisation/forgot-password"
    | "/$organisation/login"
    | "/$organisation/portal"
    | "/$organisation/portal/login"
    | "/admin/organisations"
    | "/admin/settings"
    | "/organisations/none"
    | "/organisations/select"
    | "/$organisation/settings"
    | "/admin/organisations/$organisationSlug"
    | "/admin/organisations/create"
    | "/$organisation/compliance"
    | "/$organisation/dashboard"
    | "/$organisation/filings"
    | "/$organisation/firms"
    | "/$organisation/individuals"
    | "/$organisation/issues"
    | "/$organisation/oversight"
    | "/$organisation/requests"
    | "/$organisation/reviews"
    | "/$organisation/risk"
    | "/$organisation/tasks"
    | "/$organisation/triage"
    | "/$organisation/filings/$filingId"
    | "/$organisation/firms/$firmId"
    | "/$organisation/individuals/$individualId"
    | "/$organisation/issues/$issueId"
    | "/$organisation/reviews/$reviewId"
    | "/$organisation/settings/profile"
    | "/$organisation/triage/$issueId"
    | "/$organisation/portal/tasks/$taskId"
    | "/$organisation/compliance/$gapKey"
    | "/$organisation/firms/create"
    | "/$organisation/firms/$firmId/activity"
    | "/$organisation/firms/$firmId/addresses"
    | "/$organisation/firms/$firmId/agreement"
    | "/$organisation/firms/$firmId/authorisation"
    | "/$organisation/firms/$firmId/details"
    | "/$organisation/firms/$firmId/files"
    | "/$organisation/firms/$firmId/filings"
    | "/$organisation/firms/$firmId/issues"
    | "/$organisation/firms/$firmId/onboarding"
    | "/$organisation/firms/$firmId/ownership"
    | "/$organisation/firms/$firmId/people"
    | "/$organisation/firms/$firmId/reviews"
    | "/$organisation/firms/$firmId/risk"
    | "/$organisation/firms/$firmId/scope"
    | "/$organisation/individuals/$individualId/activity"
    | "/$organisation/individuals/$individualId/addresses"
    | "/$organisation/individuals/$individualId/appointments"
    | "/$organisation/individuals/$individualId/checks"
    | "/$organisation/individuals/$individualId/employment"
    | "/$organisation/individuals/$individualId/files"
    | "/$organisation/individuals/$individualId/fitness"
    | "/$organisation/individuals/$individualId/identity"
    | "/$organisation/individuals/$individualId/issues"
    | "/$organisation/individuals/$individualId/record"
    | "/$organisation/individuals/$individualId/regulatory"
    | "/$organisation/individuals/$individualId/review"
    | "/$organisation/individuals/$individualId/reviews"
    | "/$organisation/individuals/$individualId/risk"
    | "/$organisation/reviews/$reviewId/approve"
    | "/$organisation/reviews/$reviewId/cancel"
    | "/$organisation/reviews/$reviewId/due"
    | "/$organisation/reviews/$reviewId/firm"
    | "/$organisation/settings/organisation/activity"
    | "/$organisation/settings/organisation/ar-agreements"
    | "/$organisation/settings/organisation/authorisation"
    | "/$organisation/settings/organisation/branding"
    | "/$organisation/settings/organisation/emails"
    | "/$organisation/settings/organisation/export"
    | "/$organisation/settings/organisation/offboarding"
    | "/$organisation/settings/organisation/onboarding"
    | "/$organisation/settings/organisation/requirements"
    | "/$organisation/settings/organisation/team"
    | "/$organisation/risk/factors/$factorKey"
    | "/$organisation/firms/$firmId/addresses/edit"
    | "/$organisation/firms/$firmId/agreement/$agreementId"
    | "/$organisation/firms/$firmId/authorisation/appointment"
    | "/$organisation/firms/$firmId/details/edit"
    | "/$organisation/firms/$firmId/files/$fileId"
    | "/$organisation/firms/$firmId/onboarding/new"
    | "/$organisation/firms/$firmId/ownership/edit"
    | "/$organisation/firms/$firmId/people/add"
    | "/$organisation/firms/$firmId/people/new"
    | "/$organisation/firms/$firmId/sources/companies_house"
    | "/$organisation/firms/$firmId/sources/fca"
    | "/$organisation/individuals/$individualId/addresses/edit"
    | "/$organisation/individuals/$individualId/checks/edit"
    | "/$organisation/individuals/$individualId/employment/edit"
    | "/$organisation/individuals/$individualId/files/$fileId"
    | "/$organisation/individuals/$individualId/fitness/$assessmentId"
    | "/$organisation/individuals/$individualId/identity/$documentId"
    | "/$organisation/individuals/$individualId/identity/edit"
    | "/$organisation/individuals/$individualId/record/edit"
    | "/$organisation/reviews/$reviewId/parts/$section"
    | "/$organisation/reviews/$reviewId/people/$appointmentId"
    | "/$organisation/settings/organisation/authorisation/activities"
    | "/$organisation/firms/$firmId/people/$appointmentId/end"
    | "/$organisation/individuals/$individualId/fitness/$assessmentId/record"
    | "/$organisation/reviews/$reviewId/parts/$section/$documentId"
  id:
    | "__root__"
    | "/"
    | "/$organisation"
    | "/_authenticated"
    | "/_guest"
    | "/$organisation/_authenticated"
    | "/$organisation/_guest"
    | "/_authenticated/admin"
    | "/$organisation/"
    | "/$organisation/_authenticated/_organisation"
    | "/$organisation/portal/_portal"
    | "/_authenticated/admin/"
    | "/_guest/forgot-password/"
    | "/_guest/login/"
    | "/$organisation/_authenticated/_organisation/_main"
    | "/$organisation/_authenticated/_organisation/settings"
    | "/$organisation/_guest/forgot-password/"
    | "/$organisation/_guest/login/"
    | "/$organisation/portal/_portal/"
    | "/$organisation/portal/login/"
    | "/_authenticated/admin/organisations/"
    | "/_authenticated/admin/settings/"
    | "/_authenticated/organisations/none/"
    | "/_authenticated/organisations/select/"
    | "/$organisation/_authenticated/_organisation/filings/$filingId"
    | "/$organisation/_authenticated/_organisation/firms/$firmId"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId"
    | "/$organisation/_authenticated/_organisation/issues/$issueId"
    | "/$organisation/_authenticated/_organisation/reviews/$reviewId"
    | "/$organisation/_authenticated/_organisation/triage/$issueId"
    | "/$organisation/_authenticated/_organisation/settings/"
    | "/_authenticated/admin/organisations/$organisationSlug/"
    | "/_authenticated/admin/organisations/create/"
    | "/$organisation/_authenticated/_organisation/_main/compliance/"
    | "/$organisation/_authenticated/_organisation/_main/dashboard/"
    | "/$organisation/_authenticated/_organisation/_main/filings/"
    | "/$organisation/_authenticated/_organisation/_main/firms/"
    | "/$organisation/_authenticated/_organisation/_main/individuals/"
    | "/$organisation/_authenticated/_organisation/_main/issues/"
    | "/$organisation/_authenticated/_organisation/_main/oversight/"
    | "/$organisation/_authenticated/_organisation/_main/requests/"
    | "/$organisation/_authenticated/_organisation/_main/reviews/"
    | "/$organisation/_authenticated/_organisation/_main/risk/"
    | "/$organisation/_authenticated/_organisation/_main/tasks/"
    | "/$organisation/_authenticated/_organisation/_main/triage/"
    | "/$organisation/_authenticated/_organisation/filings/$filingId/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/"
    | "/$organisation/_authenticated/_organisation/issues/$issueId/"
    | "/$organisation/_authenticated/_organisation/reviews/$reviewId/"
    | "/$organisation/_authenticated/_organisation/settings/profile/"
    | "/$organisation/_authenticated/_organisation/triage/$issueId/"
    | "/$organisation/portal/_portal/tasks/$taskId/"
    | "/$organisation/_authenticated/_organisation/_main/compliance/$gapKey/"
    | "/$organisation/_authenticated/_organisation/_main/firms/create/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/activity/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/addresses/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/agreement/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/authorisation/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/details/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/files/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/filings/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/issues/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/onboarding/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/ownership/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/people/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/reviews/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/risk/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/scope/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/activity/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/addresses/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/appointments/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/checks/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/employment/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/files/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/identity/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/issues/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/record/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/regulatory/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/review/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/reviews/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/risk/"
    | "/$organisation/_authenticated/_organisation/reviews/$reviewId/approve/"
    | "/$organisation/_authenticated/_organisation/reviews/$reviewId/cancel/"
    | "/$organisation/_authenticated/_organisation/reviews/$reviewId/due/"
    | "/$organisation/_authenticated/_organisation/reviews/$reviewId/firm/"
    | "/$organisation/_authenticated/_organisation/settings/organisation/activity/"
    | "/$organisation/_authenticated/_organisation/settings/organisation/ar-agreements/"
    | "/$organisation/_authenticated/_organisation/settings/organisation/authorisation/"
    | "/$organisation/_authenticated/_organisation/settings/organisation/branding/"
    | "/$organisation/_authenticated/_organisation/settings/organisation/emails/"
    | "/$organisation/_authenticated/_organisation/settings/organisation/export/"
    | "/$organisation/_authenticated/_organisation/settings/organisation/offboarding/"
    | "/$organisation/_authenticated/_organisation/settings/organisation/onboarding/"
    | "/$organisation/_authenticated/_organisation/settings/organisation/requirements/"
    | "/$organisation/_authenticated/_organisation/settings/organisation/team/"
    | "/$organisation/_authenticated/_organisation/_main/risk/factors/$factorKey/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/addresses/edit/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/agreement/$agreementId/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/authorisation/appointment/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/details/edit/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/files/$fileId/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/onboarding/new/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/ownership/edit/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/people/add/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/people/new/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/sources/companies_house/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/sources/fca/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/addresses/edit/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/checks/edit/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/employment/edit/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/files/$fileId/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/$assessmentId/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/identity/$documentId/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/identity/edit/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/record/edit/"
    | "/$organisation/_authenticated/_organisation/reviews/$reviewId/parts/$section/"
    | "/$organisation/_authenticated/_organisation/reviews/$reviewId/people/$appointmentId/"
    | "/$organisation/_authenticated/_organisation/settings/organisation/authorisation/activities/"
    | "/$organisation/_authenticated/_organisation/firms/$firmId/people/$appointmentId/end/"
    | "/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/$assessmentId/record/"
    | "/$organisation/_authenticated/_organisation/reviews/$reviewId/parts/$section/$documentId/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OrganisationRouteRoute: typeof OrganisationRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  GuestRouteRoute: typeof GuestRouteRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/$organisation": {
      id: "/$organisation"
      path: "/$organisation"
      fullPath: "/$organisation"
      preLoaderRoute: typeof OrganisationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_guest": {
      id: "/_guest"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof GuestRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/$organisation/": {
      id: "/$organisation/"
      path: "/"
      fullPath: "/$organisation/"
      preLoaderRoute: typeof OrganisationIndexRouteImport
      parentRoute: typeof OrganisationRouteRoute
    }
    "/$organisation/_authenticated": {
      id: "/$organisation/_authenticated"
      path: ""
      fullPath: "/$organisation"
      preLoaderRoute: typeof OrganisationAuthenticatedRouteRouteImport
      parentRoute: typeof OrganisationRouteRoute
    }
    "/$organisation/_guest": {
      id: "/$organisation/_guest"
      path: ""
      fullPath: "/$organisation"
      preLoaderRoute: typeof OrganisationGuestRouteRouteImport
      parentRoute: typeof OrganisationRouteRoute
    }
    "/_authenticated/admin": {
      id: "/_authenticated/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AuthenticatedAdminRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    "/$organisation/_authenticated/_organisation": {
      id: "/$organisation/_authenticated/_organisation"
      path: ""
      fullPath: "/$organisation"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationRouteRouteImport
      parentRoute: typeof OrganisationAuthenticatedRouteRoute
    }
    "/$organisation/portal/_portal": {
      id: "/$organisation/portal/_portal"
      path: "/portal"
      fullPath: "/$organisation/portal"
      preLoaderRoute: typeof OrganisationPortalPortalRouteRouteImport
      parentRoute: typeof OrganisationRouteRoute
    }
    "/_authenticated/admin/": {
      id: "/_authenticated/admin/"
      path: "/"
      fullPath: "/admin/"
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_guest/forgot-password/": {
      id: "/_guest/forgot-password/"
      path: "/forgot-password"
      fullPath: "/forgot-password/"
      preLoaderRoute: typeof GuestForgotPasswordIndexRouteImport
      parentRoute: typeof GuestRouteRoute
    }
    "/_guest/login/": {
      id: "/_guest/login/"
      path: "/login"
      fullPath: "/login/"
      preLoaderRoute: typeof GuestLoginIndexRouteImport
      parentRoute: typeof GuestRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main": {
      id: "/$organisation/_authenticated/_organisation/_main"
      path: ""
      fullPath: "/$organisation"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationRouteRoute
    }
    "/$organisation/_authenticated/_organisation/settings": {
      id: "/$organisation/_authenticated/_organisation/settings"
      path: "/settings"
      fullPath: "/$organisation/settings"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationSettingsRouteRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationRouteRoute
    }
    "/$organisation/_guest/forgot-password/": {
      id: "/$organisation/_guest/forgot-password/"
      path: "/forgot-password"
      fullPath: "/$organisation/forgot-password/"
      preLoaderRoute: typeof OrganisationGuestForgotPasswordIndexRouteImport
      parentRoute: typeof OrganisationGuestRouteRoute
    }
    "/$organisation/_guest/login/": {
      id: "/$organisation/_guest/login/"
      path: "/login"
      fullPath: "/$organisation/login/"
      preLoaderRoute: typeof OrganisationGuestLoginIndexRouteImport
      parentRoute: typeof OrganisationGuestRouteRoute
    }
    "/$organisation/portal/_portal/": {
      id: "/$organisation/portal/_portal/"
      path: "/"
      fullPath: "/$organisation/portal/"
      preLoaderRoute: typeof OrganisationPortalPortalIndexRouteImport
      parentRoute: typeof OrganisationPortalPortalRouteRoute
    }
    "/$organisation/portal/login/": {
      id: "/$organisation/portal/login/"
      path: "/portal/login"
      fullPath: "/$organisation/portal/login/"
      preLoaderRoute: typeof OrganisationPortalLoginIndexRouteImport
      parentRoute: typeof OrganisationRouteRoute
    }
    "/_authenticated/admin/organisations/": {
      id: "/_authenticated/admin/organisations/"
      path: "/organisations"
      fullPath: "/admin/organisations/"
      preLoaderRoute: typeof AuthenticatedAdminOrganisationsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/settings/": {
      id: "/_authenticated/admin/settings/"
      path: "/settings"
      fullPath: "/admin/settings/"
      preLoaderRoute: typeof AuthenticatedAdminSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/organisations/none/": {
      id: "/_authenticated/organisations/none/"
      path: "/organisations/none"
      fullPath: "/organisations/none/"
      preLoaderRoute: typeof AuthenticatedOrganisationsNoneIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    "/_authenticated/organisations/select/": {
      id: "/_authenticated/organisations/select/"
      path: "/organisations/select"
      fullPath: "/organisations/select/"
      preLoaderRoute: typeof AuthenticatedOrganisationsSelectIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    "/$organisation/_authenticated/_organisation/filings/$filingId": {
      id: "/$organisation/_authenticated/_organisation/filings/$filingId"
      path: "/filings/$filingId"
      fullPath: "/$organisation/filings/$filingId"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId"
      path: "/firms/$firmId"
      fullPath: "/$organisation/firms/$firmId"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId"
      path: "/individuals/$individualId"
      fullPath: "/$organisation/individuals/$individualId"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationRouteRoute
    }
    "/$organisation/_authenticated/_organisation/issues/$issueId": {
      id: "/$organisation/_authenticated/_organisation/issues/$issueId"
      path: "/issues/$issueId"
      fullPath: "/$organisation/issues/$issueId"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationRouteRoute
    }
    "/$organisation/_authenticated/_organisation/reviews/$reviewId": {
      id: "/$organisation/_authenticated/_organisation/reviews/$reviewId"
      path: "/reviews/$reviewId"
      fullPath: "/$organisation/reviews/$reviewId"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationRouteRoute
    }
    "/$organisation/_authenticated/_organisation/settings/": {
      id: "/$organisation/_authenticated/_organisation/settings/"
      path: "/"
      fullPath: "/$organisation/settings/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationSettingsIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationSettingsRouteRoute
    }
    "/$organisation/_authenticated/_organisation/triage/$issueId": {
      id: "/$organisation/_authenticated/_organisation/triage/$issueId"
      path: "/triage/$issueId"
      fullPath: "/$organisation/triage/$issueId"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationTriageIssueIdRouteRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationRouteRoute
    }
    "/_authenticated/admin/organisations/$organisationSlug/": {
      id: "/_authenticated/admin/organisations/$organisationSlug/"
      path: "/organisations/$organisationSlug"
      fullPath: "/admin/organisations/$organisationSlug/"
      preLoaderRoute: typeof AuthenticatedAdminOrganisationsOrganisationSlugIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/organisations/create/": {
      id: "/_authenticated/admin/organisations/create/"
      path: "/organisations/create"
      fullPath: "/admin/organisations/create/"
      preLoaderRoute: typeof AuthenticatedAdminOrganisationsCreateIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main/compliance/": {
      id: "/$organisation/_authenticated/_organisation/_main/compliance/"
      path: "/compliance"
      fullPath: "/$organisation/compliance/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainComplianceIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main/dashboard/": {
      id: "/$organisation/_authenticated/_organisation/_main/dashboard/"
      path: "/dashboard"
      fullPath: "/$organisation/dashboard/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainDashboardIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main/filings/": {
      id: "/$organisation/_authenticated/_organisation/_main/filings/"
      path: "/filings"
      fullPath: "/$organisation/filings/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainFilingsIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main/firms/": {
      id: "/$organisation/_authenticated/_organisation/_main/firms/"
      path: "/firms"
      fullPath: "/$organisation/firms/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainFirmsIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main/individuals/": {
      id: "/$organisation/_authenticated/_organisation/_main/individuals/"
      path: "/individuals"
      fullPath: "/$organisation/individuals/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainIndividualsIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main/issues/": {
      id: "/$organisation/_authenticated/_organisation/_main/issues/"
      path: "/issues"
      fullPath: "/$organisation/issues/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainIssuesIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main/oversight/": {
      id: "/$organisation/_authenticated/_organisation/_main/oversight/"
      path: "/oversight"
      fullPath: "/$organisation/oversight/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainOversightIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main/requests/": {
      id: "/$organisation/_authenticated/_organisation/_main/requests/"
      path: "/requests"
      fullPath: "/$organisation/requests/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainRequestsIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main/reviews/": {
      id: "/$organisation/_authenticated/_organisation/_main/reviews/"
      path: "/reviews"
      fullPath: "/$organisation/reviews/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainReviewsIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main/risk/": {
      id: "/$organisation/_authenticated/_organisation/_main/risk/"
      path: "/risk"
      fullPath: "/$organisation/risk/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainRiskIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main/tasks/": {
      id: "/$organisation/_authenticated/_organisation/_main/tasks/"
      path: "/tasks"
      fullPath: "/$organisation/tasks/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainTasksIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main/triage/": {
      id: "/$organisation/_authenticated/_organisation/_main/triage/"
      path: "/triage"
      fullPath: "/$organisation/triage/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainTriageIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRoute
    }
    "/$organisation/_authenticated/_organisation/filings/$filingId/": {
      id: "/$organisation/_authenticated/_organisation/filings/$filingId/"
      path: "/"
      fullPath: "/$organisation/filings/$filingId/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFilingsFilingIdIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/"
      path: "/"
      fullPath: "/$organisation/firms/$firmId/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/"
      path: "/"
      fullPath: "/$organisation/individuals/$individualId/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/issues/$issueId/": {
      id: "/$organisation/_authenticated/_organisation/issues/$issueId/"
      path: "/"
      fullPath: "/$organisation/issues/$issueId/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIssuesIssueIdIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/reviews/$reviewId/": {
      id: "/$organisation/_authenticated/_organisation/reviews/$reviewId/"
      path: "/"
      fullPath: "/$organisation/reviews/$reviewId/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/settings/profile/": {
      id: "/$organisation/_authenticated/_organisation/settings/profile/"
      path: "/profile"
      fullPath: "/$organisation/settings/profile/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationSettingsProfileIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationSettingsRouteRoute
    }
    "/$organisation/_authenticated/_organisation/triage/$issueId/": {
      id: "/$organisation/_authenticated/_organisation/triage/$issueId/"
      path: "/"
      fullPath: "/$organisation/triage/$issueId/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationTriageIssueIdIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationTriageIssueIdRouteRoute
    }
    "/$organisation/portal/_portal/tasks/$taskId/": {
      id: "/$organisation/portal/_portal/tasks/$taskId/"
      path: "/tasks/$taskId"
      fullPath: "/$organisation/portal/tasks/$taskId/"
      preLoaderRoute: typeof OrganisationPortalPortalTasksTaskIdIndexRouteImport
      parentRoute: typeof OrganisationPortalPortalRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main/compliance/$gapKey/": {
      id: "/$organisation/_authenticated/_organisation/_main/compliance/$gapKey/"
      path: "/compliance/$gapKey"
      fullPath: "/$organisation/compliance/$gapKey/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainComplianceGapKeyIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main/firms/create/": {
      id: "/$organisation/_authenticated/_organisation/_main/firms/create/"
      path: "/firms/create"
      fullPath: "/$organisation/firms/create/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainFirmsCreateIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/activity/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/activity/"
      path: "/activity"
      fullPath: "/$organisation/firms/$firmId/activity/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdActivityIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/addresses/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/addresses/"
      path: "/addresses"
      fullPath: "/$organisation/firms/$firmId/addresses/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/agreement/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/agreement/"
      path: "/agreement"
      fullPath: "/$organisation/firms/$firmId/agreement/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/authorisation/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/authorisation/"
      path: "/authorisation"
      fullPath: "/$organisation/firms/$firmId/authorisation/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/details/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/details/"
      path: "/details"
      fullPath: "/$organisation/firms/$firmId/details/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/files/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/files/"
      path: "/files"
      fullPath: "/$organisation/firms/$firmId/files/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdFilesIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/filings/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/filings/"
      path: "/filings"
      fullPath: "/$organisation/firms/$firmId/filings/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdFilingsIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/issues/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/issues/"
      path: "/issues"
      fullPath: "/$organisation/firms/$firmId/issues/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdIssuesIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/onboarding/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/onboarding/"
      path: "/onboarding"
      fullPath: "/$organisation/firms/$firmId/onboarding/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/ownership/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/ownership/"
      path: "/ownership"
      fullPath: "/$organisation/firms/$firmId/ownership/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/people/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/people/"
      path: "/people"
      fullPath: "/$organisation/firms/$firmId/people/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/reviews/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/reviews/"
      path: "/reviews"
      fullPath: "/$organisation/firms/$firmId/reviews/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdReviewsIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/risk/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/risk/"
      path: "/risk"
      fullPath: "/$organisation/firms/$firmId/risk/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRiskIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/scope/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/scope/"
      path: "/scope"
      fullPath: "/$organisation/firms/$firmId/scope/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdScopeIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/activity/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/activity/"
      path: "/activity"
      fullPath: "/$organisation/individuals/$individualId/activity/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdActivityIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/addresses/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/addresses/"
      path: "/addresses"
      fullPath: "/$organisation/individuals/$individualId/addresses/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/appointments/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/appointments/"
      path: "/appointments"
      fullPath: "/$organisation/individuals/$individualId/appointments/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdAppointmentsIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/checks/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/checks/"
      path: "/checks"
      fullPath: "/$organisation/individuals/$individualId/checks/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/employment/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/employment/"
      path: "/employment"
      fullPath: "/$organisation/individuals/$individualId/employment/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/files/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/files/"
      path: "/files"
      fullPath: "/$organisation/individuals/$individualId/files/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/"
      path: "/fitness"
      fullPath: "/$organisation/individuals/$individualId/fitness/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/identity/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/identity/"
      path: "/identity"
      fullPath: "/$organisation/individuals/$individualId/identity/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/issues/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/issues/"
      path: "/issues"
      fullPath: "/$organisation/individuals/$individualId/issues/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIssuesIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/record/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/record/"
      path: "/record"
      fullPath: "/$organisation/individuals/$individualId/record/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/regulatory/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/regulatory/"
      path: "/regulatory"
      fullPath: "/$organisation/individuals/$individualId/regulatory/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRegulatoryIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/review/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/review/"
      path: "/review"
      fullPath: "/$organisation/individuals/$individualId/review/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/reviews/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/reviews/"
      path: "/reviews"
      fullPath: "/$organisation/individuals/$individualId/reviews/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewsIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/risk/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/risk/"
      path: "/risk"
      fullPath: "/$organisation/individuals/$individualId/risk/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRiskIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/reviews/$reviewId/approve/": {
      id: "/$organisation/_authenticated/_organisation/reviews/$reviewId/approve/"
      path: "/approve"
      fullPath: "/$organisation/reviews/$reviewId/approve/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdApproveIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/reviews/$reviewId/cancel/": {
      id: "/$organisation/_authenticated/_organisation/reviews/$reviewId/cancel/"
      path: "/cancel"
      fullPath: "/$organisation/reviews/$reviewId/cancel/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdCancelIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/reviews/$reviewId/due/": {
      id: "/$organisation/_authenticated/_organisation/reviews/$reviewId/due/"
      path: "/due"
      fullPath: "/$organisation/reviews/$reviewId/due/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdDueIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/reviews/$reviewId/firm/": {
      id: "/$organisation/_authenticated/_organisation/reviews/$reviewId/firm/"
      path: "/firm"
      fullPath: "/$organisation/reviews/$reviewId/firm/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdFirmIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/settings/organisation/activity/": {
      id: "/$organisation/_authenticated/_organisation/settings/organisation/activity/"
      path: "/organisation/activity"
      fullPath: "/$organisation/settings/organisation/activity/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationActivityIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationSettingsRouteRoute
    }
    "/$organisation/_authenticated/_organisation/settings/organisation/ar-agreements/": {
      id: "/$organisation/_authenticated/_organisation/settings/organisation/ar-agreements/"
      path: "/organisation/ar-agreements"
      fullPath: "/$organisation/settings/organisation/ar-agreements/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationArAgreementsIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationSettingsRouteRoute
    }
    "/$organisation/_authenticated/_organisation/settings/organisation/authorisation/": {
      id: "/$organisation/_authenticated/_organisation/settings/organisation/authorisation/"
      path: "/organisation/authorisation"
      fullPath: "/$organisation/settings/organisation/authorisation/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationSettingsRouteRoute
    }
    "/$organisation/_authenticated/_organisation/settings/organisation/branding/": {
      id: "/$organisation/_authenticated/_organisation/settings/organisation/branding/"
      path: "/organisation/branding"
      fullPath: "/$organisation/settings/organisation/branding/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationBrandingIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationSettingsRouteRoute
    }
    "/$organisation/_authenticated/_organisation/settings/organisation/emails/": {
      id: "/$organisation/_authenticated/_organisation/settings/organisation/emails/"
      path: "/organisation/emails"
      fullPath: "/$organisation/settings/organisation/emails/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationEmailsIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationSettingsRouteRoute
    }
    "/$organisation/_authenticated/_organisation/settings/organisation/export/": {
      id: "/$organisation/_authenticated/_organisation/settings/organisation/export/"
      path: "/organisation/export"
      fullPath: "/$organisation/settings/organisation/export/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationExportIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationSettingsRouteRoute
    }
    "/$organisation/_authenticated/_organisation/settings/organisation/offboarding/": {
      id: "/$organisation/_authenticated/_organisation/settings/organisation/offboarding/"
      path: "/organisation/offboarding"
      fullPath: "/$organisation/settings/organisation/offboarding/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationOffboardingIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationSettingsRouteRoute
    }
    "/$organisation/_authenticated/_organisation/settings/organisation/onboarding/": {
      id: "/$organisation/_authenticated/_organisation/settings/organisation/onboarding/"
      path: "/organisation/onboarding"
      fullPath: "/$organisation/settings/organisation/onboarding/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationOnboardingIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationSettingsRouteRoute
    }
    "/$organisation/_authenticated/_organisation/settings/organisation/requirements/": {
      id: "/$organisation/_authenticated/_organisation/settings/organisation/requirements/"
      path: "/organisation/requirements"
      fullPath: "/$organisation/settings/organisation/requirements/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationRequirementsIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationSettingsRouteRoute
    }
    "/$organisation/_authenticated/_organisation/settings/organisation/team/": {
      id: "/$organisation/_authenticated/_organisation/settings/organisation/team/"
      path: "/organisation/team"
      fullPath: "/$organisation/settings/organisation/team/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationTeamIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationSettingsRouteRoute
    }
    "/$organisation/_authenticated/_organisation/_main/risk/factors/$factorKey/": {
      id: "/$organisation/_authenticated/_organisation/_main/risk/factors/$factorKey/"
      path: "/risk/factors/$factorKey"
      fullPath: "/$organisation/risk/factors/$factorKey/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationMainRiskFactorsFactorKeyIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/addresses/edit/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/addresses/edit/"
      path: "/addresses/edit"
      fullPath: "/$organisation/firms/$firmId/addresses/edit/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesEditIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/agreement/$agreementId/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/agreement/$agreementId/"
      path: "/agreement/$agreementId"
      fullPath: "/$organisation/firms/$firmId/agreement/$agreementId/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementAgreementIdIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/authorisation/appointment/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/authorisation/appointment/"
      path: "/authorisation/appointment"
      fullPath: "/$organisation/firms/$firmId/authorisation/appointment/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationAppointmentIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/details/edit/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/details/edit/"
      path: "/details/edit"
      fullPath: "/$organisation/firms/$firmId/details/edit/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsEditIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/files/$fileId/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/files/$fileId/"
      path: "/files/$fileId"
      fullPath: "/$organisation/firms/$firmId/files/$fileId/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdFilesFileIdIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/onboarding/new/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/onboarding/new/"
      path: "/onboarding/new"
      fullPath: "/$organisation/firms/$firmId/onboarding/new/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingNewIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/ownership/edit/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/ownership/edit/"
      path: "/ownership/edit"
      fullPath: "/$organisation/firms/$firmId/ownership/edit/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipEditIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/people/add/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/people/add/"
      path: "/people/add"
      fullPath: "/$organisation/firms/$firmId/people/add/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAddIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/people/new/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/people/new/"
      path: "/people/new"
      fullPath: "/$organisation/firms/$firmId/people/new/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleNewIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/sources/companies_house/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/sources/companies_house/"
      path: "/sources/companies_house"
      fullPath: "/$organisation/firms/$firmId/sources/companies_house/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesCompanies_houseIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/sources/fca/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/sources/fca/"
      path: "/sources/fca"
      fullPath: "/$organisation/firms/$firmId/sources/fca/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesFcaIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/addresses/edit/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/addresses/edit/"
      path: "/addresses/edit"
      fullPath: "/$organisation/individuals/$individualId/addresses/edit/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesEditIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/checks/edit/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/checks/edit/"
      path: "/checks/edit"
      fullPath: "/$organisation/individuals/$individualId/checks/edit/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksEditIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/employment/edit/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/employment/edit/"
      path: "/employment/edit"
      fullPath: "/$organisation/individuals/$individualId/employment/edit/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentEditIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/files/$fileId/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/files/$fileId/"
      path: "/files/$fileId"
      fullPath: "/$organisation/individuals/$individualId/files/$fileId/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesFileIdIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/$assessmentId/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/$assessmentId/"
      path: "/fitness/$assessmentId"
      fullPath: "/$organisation/individuals/$individualId/fitness/$assessmentId/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/identity/$documentId/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/identity/$documentId/"
      path: "/identity/$documentId"
      fullPath: "/$organisation/individuals/$individualId/identity/$documentId/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityDocumentIdIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/identity/edit/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/identity/edit/"
      path: "/identity/edit"
      fullPath: "/$organisation/individuals/$individualId/identity/edit/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityEditIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/record/edit/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/record/edit/"
      path: "/record/edit"
      fullPath: "/$organisation/individuals/$individualId/record/edit/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordEditIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/reviews/$reviewId/parts/$section/": {
      id: "/$organisation/_authenticated/_organisation/reviews/$reviewId/parts/$section/"
      path: "/parts/$section"
      fullPath: "/$organisation/reviews/$reviewId/parts/$section/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/reviews/$reviewId/people/$appointmentId/": {
      id: "/$organisation/_authenticated/_organisation/reviews/$reviewId/people/$appointmentId/"
      path: "/people/$appointmentId"
      fullPath: "/$organisation/reviews/$reviewId/people/$appointmentId/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdPeopleAppointmentIdIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/settings/organisation/authorisation/activities/": {
      id: "/$organisation/_authenticated/_organisation/settings/organisation/authorisation/activities/"
      path: "/organisation/authorisation/activities"
      fullPath: "/$organisation/settings/organisation/authorisation/activities/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationActivitiesIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationSettingsRouteRoute
    }
    "/$organisation/_authenticated/_organisation/firms/$firmId/people/$appointmentId/end/": {
      id: "/$organisation/_authenticated/_organisation/firms/$firmId/people/$appointmentId/end/"
      path: "/people/$appointmentId/end"
      fullPath: "/$organisation/firms/$firmId/people/$appointmentId/end/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAppointmentIdEndIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/$assessmentId/record/": {
      id: "/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/$assessmentId/record/"
      path: "/fitness/$assessmentId/record"
      fullPath: "/$organisation/individuals/$individualId/fitness/$assessmentId/record/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdRecordIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute
    }
    "/$organisation/_authenticated/_organisation/reviews/$reviewId/parts/$section/$documentId/": {
      id: "/$organisation/_authenticated/_organisation/reviews/$reviewId/parts/$section/$documentId/"
      path: "/parts/$section/$documentId"
      fullPath: "/$organisation/reviews/$reviewId/parts/$section/$documentId/"
      preLoaderRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionDocumentIdIndexRouteImport
      parentRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute
    }
  }
}

interface OrganisationAuthenticatedOrganisationMainRouteRouteChildren {
  OrganisationAuthenticatedOrganisationMainComplianceIndexRoute: typeof OrganisationAuthenticatedOrganisationMainComplianceIndexRoute
  OrganisationAuthenticatedOrganisationMainDashboardIndexRoute: typeof OrganisationAuthenticatedOrganisationMainDashboardIndexRoute
  OrganisationAuthenticatedOrganisationMainFilingsIndexRoute: typeof OrganisationAuthenticatedOrganisationMainFilingsIndexRoute
  OrganisationAuthenticatedOrganisationMainFirmsIndexRoute: typeof OrganisationAuthenticatedOrganisationMainFirmsIndexRoute
  OrganisationAuthenticatedOrganisationMainIndividualsIndexRoute: typeof OrganisationAuthenticatedOrganisationMainIndividualsIndexRoute
  OrganisationAuthenticatedOrganisationMainIssuesIndexRoute: typeof OrganisationAuthenticatedOrganisationMainIssuesIndexRoute
  OrganisationAuthenticatedOrganisationMainOversightIndexRoute: typeof OrganisationAuthenticatedOrganisationMainOversightIndexRoute
  OrganisationAuthenticatedOrganisationMainRequestsIndexRoute: typeof OrganisationAuthenticatedOrganisationMainRequestsIndexRoute
  OrganisationAuthenticatedOrganisationMainReviewsIndexRoute: typeof OrganisationAuthenticatedOrganisationMainReviewsIndexRoute
  OrganisationAuthenticatedOrganisationMainRiskIndexRoute: typeof OrganisationAuthenticatedOrganisationMainRiskIndexRoute
  OrganisationAuthenticatedOrganisationMainTasksIndexRoute: typeof OrganisationAuthenticatedOrganisationMainTasksIndexRoute
  OrganisationAuthenticatedOrganisationMainTriageIndexRoute: typeof OrganisationAuthenticatedOrganisationMainTriageIndexRoute
  OrganisationAuthenticatedOrganisationMainComplianceGapKeyIndexRoute: typeof OrganisationAuthenticatedOrganisationMainComplianceGapKeyIndexRoute
  OrganisationAuthenticatedOrganisationMainFirmsCreateIndexRoute: typeof OrganisationAuthenticatedOrganisationMainFirmsCreateIndexRoute
  OrganisationAuthenticatedOrganisationMainRiskFactorsFactorKeyIndexRoute: typeof OrganisationAuthenticatedOrganisationMainRiskFactorsFactorKeyIndexRoute
}

const OrganisationAuthenticatedOrganisationMainRouteRouteChildren: OrganisationAuthenticatedOrganisationMainRouteRouteChildren =
  {
    OrganisationAuthenticatedOrganisationMainComplianceIndexRoute:
      OrganisationAuthenticatedOrganisationMainComplianceIndexRoute,
    OrganisationAuthenticatedOrganisationMainDashboardIndexRoute:
      OrganisationAuthenticatedOrganisationMainDashboardIndexRoute,
    OrganisationAuthenticatedOrganisationMainFilingsIndexRoute:
      OrganisationAuthenticatedOrganisationMainFilingsIndexRoute,
    OrganisationAuthenticatedOrganisationMainFirmsIndexRoute:
      OrganisationAuthenticatedOrganisationMainFirmsIndexRoute,
    OrganisationAuthenticatedOrganisationMainIndividualsIndexRoute:
      OrganisationAuthenticatedOrganisationMainIndividualsIndexRoute,
    OrganisationAuthenticatedOrganisationMainIssuesIndexRoute:
      OrganisationAuthenticatedOrganisationMainIssuesIndexRoute,
    OrganisationAuthenticatedOrganisationMainOversightIndexRoute:
      OrganisationAuthenticatedOrganisationMainOversightIndexRoute,
    OrganisationAuthenticatedOrganisationMainRequestsIndexRoute:
      OrganisationAuthenticatedOrganisationMainRequestsIndexRoute,
    OrganisationAuthenticatedOrganisationMainReviewsIndexRoute:
      OrganisationAuthenticatedOrganisationMainReviewsIndexRoute,
    OrganisationAuthenticatedOrganisationMainRiskIndexRoute:
      OrganisationAuthenticatedOrganisationMainRiskIndexRoute,
    OrganisationAuthenticatedOrganisationMainTasksIndexRoute:
      OrganisationAuthenticatedOrganisationMainTasksIndexRoute,
    OrganisationAuthenticatedOrganisationMainTriageIndexRoute:
      OrganisationAuthenticatedOrganisationMainTriageIndexRoute,
    OrganisationAuthenticatedOrganisationMainComplianceGapKeyIndexRoute:
      OrganisationAuthenticatedOrganisationMainComplianceGapKeyIndexRoute,
    OrganisationAuthenticatedOrganisationMainFirmsCreateIndexRoute:
      OrganisationAuthenticatedOrganisationMainFirmsCreateIndexRoute,
    OrganisationAuthenticatedOrganisationMainRiskFactorsFactorKeyIndexRoute:
      OrganisationAuthenticatedOrganisationMainRiskFactorsFactorKeyIndexRoute,
  }

const OrganisationAuthenticatedOrganisationMainRouteRouteWithChildren =
  OrganisationAuthenticatedOrganisationMainRouteRoute._addFileChildren(
    OrganisationAuthenticatedOrganisationMainRouteRouteChildren,
  )

interface OrganisationAuthenticatedOrganisationSettingsRouteRouteChildren {
  OrganisationAuthenticatedOrganisationSettingsIndexRoute: typeof OrganisationAuthenticatedOrganisationSettingsIndexRoute
  OrganisationAuthenticatedOrganisationSettingsProfileIndexRoute: typeof OrganisationAuthenticatedOrganisationSettingsProfileIndexRoute
  OrganisationAuthenticatedOrganisationSettingsOrganisationActivityIndexRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationActivityIndexRoute
  OrganisationAuthenticatedOrganisationSettingsOrganisationArAgreementsIndexRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationArAgreementsIndexRoute
  OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationIndexRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationIndexRoute
  OrganisationAuthenticatedOrganisationSettingsOrganisationBrandingIndexRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationBrandingIndexRoute
  OrganisationAuthenticatedOrganisationSettingsOrganisationEmailsIndexRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationEmailsIndexRoute
  OrganisationAuthenticatedOrganisationSettingsOrganisationExportIndexRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationExportIndexRoute
  OrganisationAuthenticatedOrganisationSettingsOrganisationOffboardingIndexRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationOffboardingIndexRoute
  OrganisationAuthenticatedOrganisationSettingsOrganisationOnboardingIndexRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationOnboardingIndexRoute
  OrganisationAuthenticatedOrganisationSettingsOrganisationRequirementsIndexRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationRequirementsIndexRoute
  OrganisationAuthenticatedOrganisationSettingsOrganisationTeamIndexRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationTeamIndexRoute
  OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationActivitiesIndexRoute: typeof OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationActivitiesIndexRoute
}

const OrganisationAuthenticatedOrganisationSettingsRouteRouteChildren: OrganisationAuthenticatedOrganisationSettingsRouteRouteChildren =
  {
    OrganisationAuthenticatedOrganisationSettingsIndexRoute:
      OrganisationAuthenticatedOrganisationSettingsIndexRoute,
    OrganisationAuthenticatedOrganisationSettingsProfileIndexRoute:
      OrganisationAuthenticatedOrganisationSettingsProfileIndexRoute,
    OrganisationAuthenticatedOrganisationSettingsOrganisationActivityIndexRoute:
      OrganisationAuthenticatedOrganisationSettingsOrganisationActivityIndexRoute,
    OrganisationAuthenticatedOrganisationSettingsOrganisationArAgreementsIndexRoute:
      OrganisationAuthenticatedOrganisationSettingsOrganisationArAgreementsIndexRoute,
    OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationIndexRoute:
      OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationIndexRoute,
    OrganisationAuthenticatedOrganisationSettingsOrganisationBrandingIndexRoute:
      OrganisationAuthenticatedOrganisationSettingsOrganisationBrandingIndexRoute,
    OrganisationAuthenticatedOrganisationSettingsOrganisationEmailsIndexRoute:
      OrganisationAuthenticatedOrganisationSettingsOrganisationEmailsIndexRoute,
    OrganisationAuthenticatedOrganisationSettingsOrganisationExportIndexRoute:
      OrganisationAuthenticatedOrganisationSettingsOrganisationExportIndexRoute,
    OrganisationAuthenticatedOrganisationSettingsOrganisationOffboardingIndexRoute:
      OrganisationAuthenticatedOrganisationSettingsOrganisationOffboardingIndexRoute,
    OrganisationAuthenticatedOrganisationSettingsOrganisationOnboardingIndexRoute:
      OrganisationAuthenticatedOrganisationSettingsOrganisationOnboardingIndexRoute,
    OrganisationAuthenticatedOrganisationSettingsOrganisationRequirementsIndexRoute:
      OrganisationAuthenticatedOrganisationSettingsOrganisationRequirementsIndexRoute,
    OrganisationAuthenticatedOrganisationSettingsOrganisationTeamIndexRoute:
      OrganisationAuthenticatedOrganisationSettingsOrganisationTeamIndexRoute,
    OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationActivitiesIndexRoute:
      OrganisationAuthenticatedOrganisationSettingsOrganisationAuthorisationActivitiesIndexRoute,
  }

const OrganisationAuthenticatedOrganisationSettingsRouteRouteWithChildren =
  OrganisationAuthenticatedOrganisationSettingsRouteRoute._addFileChildren(
    OrganisationAuthenticatedOrganisationSettingsRouteRouteChildren,
  )

interface OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRouteChildren {
  OrganisationAuthenticatedOrganisationFilingsFilingIdIndexRoute: typeof OrganisationAuthenticatedOrganisationFilingsFilingIdIndexRoute
}

const OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRouteChildren: OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRouteChildren =
  {
    OrganisationAuthenticatedOrganisationFilingsFilingIdIndexRoute:
      OrganisationAuthenticatedOrganisationFilingsFilingIdIndexRoute,
  }

const OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRouteWithChildren =
  OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRoute._addFileChildren(
    OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRouteChildren,
  )

interface OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRouteChildren {
  OrganisationAuthenticatedOrganisationFirmsFirmIdIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdActivityIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdActivityIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdFilesIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdFilesIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdFilingsIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdFilingsIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdIssuesIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdIssuesIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdReviewsIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdReviewsIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdRiskIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRiskIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdScopeIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdScopeIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesEditIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesEditIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementAgreementIdIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementAgreementIdIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationAppointmentIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationAppointmentIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsEditIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsEditIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdFilesFileIdIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdFilesFileIdIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingNewIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingNewIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipEditIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipEditIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAddIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAddIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleNewIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleNewIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesCompanies_houseIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesCompanies_houseIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesFcaIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesFcaIndexRoute
  OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAppointmentIdEndIndexRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAppointmentIdEndIndexRoute
}

const OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRouteChildren: OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRouteChildren =
  {
    OrganisationAuthenticatedOrganisationFirmsFirmIdIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdActivityIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdActivityIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdFilesIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdFilesIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdFilingsIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdFilingsIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdIssuesIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdIssuesIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdReviewsIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdReviewsIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdRiskIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdRiskIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdScopeIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdScopeIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesEditIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdAddressesEditIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementAgreementIdIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdAgreementAgreementIdIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationAppointmentIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdAuthorisationAppointmentIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsEditIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdDetailsEditIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdFilesFileIdIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdFilesFileIdIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingNewIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdOnboardingNewIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipEditIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdOwnershipEditIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAddIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAddIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleNewIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleNewIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesCompanies_houseIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesCompanies_houseIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesFcaIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdSourcesFcaIndexRoute,
    OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAppointmentIdEndIndexRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdPeopleAppointmentIdEndIndexRoute,
  }

const OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRouteWithChildren =
  OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute._addFileChildren(
    OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRouteChildren,
  )

interface OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRouteChildren {
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdActivityIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdActivityIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdAppointmentsIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdAppointmentsIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdIssuesIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIssuesIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdRegulatoryIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRegulatoryIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewsIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewsIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdRiskIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRiskIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesEditIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesEditIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksEditIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksEditIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentEditIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentEditIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesFileIdIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesFileIdIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityDocumentIdIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityDocumentIdIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityEditIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityEditIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordEditIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordEditIndexRoute
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdRecordIndexRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdRecordIndexRoute
}

const OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRouteChildren: OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRouteChildren =
  {
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdActivityIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdActivityIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdAppointmentsIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdAppointmentsIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdIssuesIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdIssuesIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdRegulatoryIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdRegulatoryIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewsIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdReviewsIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdRiskIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdRiskIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesEditIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdAddressesEditIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksEditIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdChecksEditIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentEditIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdEmploymentEditIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesFileIdIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdFilesFileIdIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityDocumentIdIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityDocumentIdIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityEditIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdIdentityEditIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordEditIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdRecordEditIndexRoute,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdRecordIndexRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdFitnessAssessmentIdRecordIndexRoute,
  }

const OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRouteWithChildren =
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute._addFileChildren(
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRouteChildren,
  )

interface OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRouteChildren {
  OrganisationAuthenticatedOrganisationIssuesIssueIdIndexRoute: typeof OrganisationAuthenticatedOrganisationIssuesIssueIdIndexRoute
}

const OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRouteChildren: OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRouteChildren =
  {
    OrganisationAuthenticatedOrganisationIssuesIssueIdIndexRoute:
      OrganisationAuthenticatedOrganisationIssuesIssueIdIndexRoute,
  }

const OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRouteWithChildren =
  OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRoute._addFileChildren(
    OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRouteChildren,
  )

interface OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRouteChildren {
  OrganisationAuthenticatedOrganisationReviewsReviewIdIndexRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdIndexRoute
  OrganisationAuthenticatedOrganisationReviewsReviewIdApproveIndexRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdApproveIndexRoute
  OrganisationAuthenticatedOrganisationReviewsReviewIdCancelIndexRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdCancelIndexRoute
  OrganisationAuthenticatedOrganisationReviewsReviewIdDueIndexRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdDueIndexRoute
  OrganisationAuthenticatedOrganisationReviewsReviewIdFirmIndexRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdFirmIndexRoute
  OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionIndexRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionIndexRoute
  OrganisationAuthenticatedOrganisationReviewsReviewIdPeopleAppointmentIdIndexRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdPeopleAppointmentIdIndexRoute
  OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionDocumentIdIndexRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionDocumentIdIndexRoute
}

const OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRouteChildren: OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRouteChildren =
  {
    OrganisationAuthenticatedOrganisationReviewsReviewIdIndexRoute:
      OrganisationAuthenticatedOrganisationReviewsReviewIdIndexRoute,
    OrganisationAuthenticatedOrganisationReviewsReviewIdApproveIndexRoute:
      OrganisationAuthenticatedOrganisationReviewsReviewIdApproveIndexRoute,
    OrganisationAuthenticatedOrganisationReviewsReviewIdCancelIndexRoute:
      OrganisationAuthenticatedOrganisationReviewsReviewIdCancelIndexRoute,
    OrganisationAuthenticatedOrganisationReviewsReviewIdDueIndexRoute:
      OrganisationAuthenticatedOrganisationReviewsReviewIdDueIndexRoute,
    OrganisationAuthenticatedOrganisationReviewsReviewIdFirmIndexRoute:
      OrganisationAuthenticatedOrganisationReviewsReviewIdFirmIndexRoute,
    OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionIndexRoute:
      OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionIndexRoute,
    OrganisationAuthenticatedOrganisationReviewsReviewIdPeopleAppointmentIdIndexRoute:
      OrganisationAuthenticatedOrganisationReviewsReviewIdPeopleAppointmentIdIndexRoute,
    OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionDocumentIdIndexRoute:
      OrganisationAuthenticatedOrganisationReviewsReviewIdPartsSectionDocumentIdIndexRoute,
  }

const OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRouteWithChildren =
  OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute._addFileChildren(
    OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRouteChildren,
  )

interface OrganisationAuthenticatedOrganisationTriageIssueIdRouteRouteChildren {
  OrganisationAuthenticatedOrganisationTriageIssueIdIndexRoute: typeof OrganisationAuthenticatedOrganisationTriageIssueIdIndexRoute
}

const OrganisationAuthenticatedOrganisationTriageIssueIdRouteRouteChildren: OrganisationAuthenticatedOrganisationTriageIssueIdRouteRouteChildren =
  {
    OrganisationAuthenticatedOrganisationTriageIssueIdIndexRoute:
      OrganisationAuthenticatedOrganisationTriageIssueIdIndexRoute,
  }

const OrganisationAuthenticatedOrganisationTriageIssueIdRouteRouteWithChildren =
  OrganisationAuthenticatedOrganisationTriageIssueIdRouteRoute._addFileChildren(
    OrganisationAuthenticatedOrganisationTriageIssueIdRouteRouteChildren,
  )

interface OrganisationAuthenticatedOrganisationRouteRouteChildren {
  OrganisationAuthenticatedOrganisationMainRouteRoute: typeof OrganisationAuthenticatedOrganisationMainRouteRouteWithChildren
  OrganisationAuthenticatedOrganisationSettingsRouteRoute: typeof OrganisationAuthenticatedOrganisationSettingsRouteRouteWithChildren
  OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRoute: typeof OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRouteWithChildren
  OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute: typeof OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRouteWithChildren
  OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute: typeof OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRouteWithChildren
  OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRoute: typeof OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRouteWithChildren
  OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute: typeof OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRouteWithChildren
  OrganisationAuthenticatedOrganisationTriageIssueIdRouteRoute: typeof OrganisationAuthenticatedOrganisationTriageIssueIdRouteRouteWithChildren
}

const OrganisationAuthenticatedOrganisationRouteRouteChildren: OrganisationAuthenticatedOrganisationRouteRouteChildren =
  {
    OrganisationAuthenticatedOrganisationMainRouteRoute:
      OrganisationAuthenticatedOrganisationMainRouteRouteWithChildren,
    OrganisationAuthenticatedOrganisationSettingsRouteRoute:
      OrganisationAuthenticatedOrganisationSettingsRouteRouteWithChildren,
    OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRoute:
      OrganisationAuthenticatedOrganisationFilingsFilingIdRouteRouteWithChildren,
    OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRoute:
      OrganisationAuthenticatedOrganisationFirmsFirmIdRouteRouteWithChildren,
    OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRoute:
      OrganisationAuthenticatedOrganisationIndividualsIndividualIdRouteRouteWithChildren,
    OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRoute:
      OrganisationAuthenticatedOrganisationIssuesIssueIdRouteRouteWithChildren,
    OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRoute:
      OrganisationAuthenticatedOrganisationReviewsReviewIdRouteRouteWithChildren,
    OrganisationAuthenticatedOrganisationTriageIssueIdRouteRoute:
      OrganisationAuthenticatedOrganisationTriageIssueIdRouteRouteWithChildren,
  }

const OrganisationAuthenticatedOrganisationRouteRouteWithChildren =
  OrganisationAuthenticatedOrganisationRouteRoute._addFileChildren(
    OrganisationAuthenticatedOrganisationRouteRouteChildren,
  )

interface OrganisationAuthenticatedRouteRouteChildren {
  OrganisationAuthenticatedOrganisationRouteRoute: typeof OrganisationAuthenticatedOrganisationRouteRouteWithChildren
}

const OrganisationAuthenticatedRouteRouteChildren: OrganisationAuthenticatedRouteRouteChildren =
  {
    OrganisationAuthenticatedOrganisationRouteRoute:
      OrganisationAuthenticatedOrganisationRouteRouteWithChildren,
  }

const OrganisationAuthenticatedRouteRouteWithChildren =
  OrganisationAuthenticatedRouteRoute._addFileChildren(
    OrganisationAuthenticatedRouteRouteChildren,
  )

interface OrganisationGuestRouteRouteChildren {
  OrganisationGuestForgotPasswordIndexRoute: typeof OrganisationGuestForgotPasswordIndexRoute
  OrganisationGuestLoginIndexRoute: typeof OrganisationGuestLoginIndexRoute
}

const OrganisationGuestRouteRouteChildren: OrganisationGuestRouteRouteChildren =
  {
    OrganisationGuestForgotPasswordIndexRoute:
      OrganisationGuestForgotPasswordIndexRoute,
    OrganisationGuestLoginIndexRoute: OrganisationGuestLoginIndexRoute,
  }

const OrganisationGuestRouteRouteWithChildren =
  OrganisationGuestRouteRoute._addFileChildren(
    OrganisationGuestRouteRouteChildren,
  )

interface OrganisationPortalPortalRouteRouteChildren {
  OrganisationPortalPortalIndexRoute: typeof OrganisationPortalPortalIndexRoute
  OrganisationPortalPortalTasksTaskIdIndexRoute: typeof OrganisationPortalPortalTasksTaskIdIndexRoute
}

const OrganisationPortalPortalRouteRouteChildren: OrganisationPortalPortalRouteRouteChildren =
  {
    OrganisationPortalPortalIndexRoute: OrganisationPortalPortalIndexRoute,
    OrganisationPortalPortalTasksTaskIdIndexRoute:
      OrganisationPortalPortalTasksTaskIdIndexRoute,
  }

const OrganisationPortalPortalRouteRouteWithChildren =
  OrganisationPortalPortalRouteRoute._addFileChildren(
    OrganisationPortalPortalRouteRouteChildren,
  )

interface OrganisationRouteRouteChildren {
  OrganisationAuthenticatedRouteRoute: typeof OrganisationAuthenticatedRouteRouteWithChildren
  OrganisationGuestRouteRoute: typeof OrganisationGuestRouteRouteWithChildren
  OrganisationIndexRoute: typeof OrganisationIndexRoute
  OrganisationPortalPortalRouteRoute: typeof OrganisationPortalPortalRouteRouteWithChildren
  OrganisationPortalLoginIndexRoute: typeof OrganisationPortalLoginIndexRoute
}

const OrganisationRouteRouteChildren: OrganisationRouteRouteChildren = {
  OrganisationAuthenticatedRouteRoute:
    OrganisationAuthenticatedRouteRouteWithChildren,
  OrganisationGuestRouteRoute: OrganisationGuestRouteRouteWithChildren,
  OrganisationIndexRoute: OrganisationIndexRoute,
  OrganisationPortalPortalRouteRoute:
    OrganisationPortalPortalRouteRouteWithChildren,
  OrganisationPortalLoginIndexRoute: OrganisationPortalLoginIndexRoute,
}

const OrganisationRouteRouteWithChildren =
  OrganisationRouteRoute._addFileChildren(OrganisationRouteRouteChildren)

interface AuthenticatedAdminRouteRouteChildren {
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminOrganisationsIndexRoute: typeof AuthenticatedAdminOrganisationsIndexRoute
  AuthenticatedAdminSettingsIndexRoute: typeof AuthenticatedAdminSettingsIndexRoute
  AuthenticatedAdminOrganisationsOrganisationSlugIndexRoute: typeof AuthenticatedAdminOrganisationsOrganisationSlugIndexRoute
  AuthenticatedAdminOrganisationsCreateIndexRoute: typeof AuthenticatedAdminOrganisationsCreateIndexRoute
}

const AuthenticatedAdminRouteRouteChildren: AuthenticatedAdminRouteRouteChildren =
  {
    AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
    AuthenticatedAdminOrganisationsIndexRoute:
      AuthenticatedAdminOrganisationsIndexRoute,
    AuthenticatedAdminSettingsIndexRoute: AuthenticatedAdminSettingsIndexRoute,
    AuthenticatedAdminOrganisationsOrganisationSlugIndexRoute:
      AuthenticatedAdminOrganisationsOrganisationSlugIndexRoute,
    AuthenticatedAdminOrganisationsCreateIndexRoute:
      AuthenticatedAdminOrganisationsCreateIndexRoute,
  }

const AuthenticatedAdminRouteRouteWithChildren =
  AuthenticatedAdminRouteRoute._addFileChildren(
    AuthenticatedAdminRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRouteRoute: typeof AuthenticatedAdminRouteRouteWithChildren
  AuthenticatedOrganisationsNoneIndexRoute: typeof AuthenticatedOrganisationsNoneIndexRoute
  AuthenticatedOrganisationsSelectIndexRoute: typeof AuthenticatedOrganisationsSelectIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,
  AuthenticatedOrganisationsNoneIndexRoute:
    AuthenticatedOrganisationsNoneIndexRoute,
  AuthenticatedOrganisationsSelectIndexRoute:
    AuthenticatedOrganisationsSelectIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface GuestRouteRouteChildren {
  GuestForgotPasswordIndexRoute: typeof GuestForgotPasswordIndexRoute
  GuestLoginIndexRoute: typeof GuestLoginIndexRoute
}

const GuestRouteRouteChildren: GuestRouteRouteChildren = {
  GuestForgotPasswordIndexRoute: GuestForgotPasswordIndexRoute,
  GuestLoginIndexRoute: GuestLoginIndexRoute,
}

const GuestRouteRouteWithChildren = GuestRouteRoute._addFileChildren(
  GuestRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OrganisationRouteRoute: OrganisationRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  GuestRouteRoute: GuestRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
